/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login/route'
import { Route as SiteRouteImport } from './routes/_site/route'
import { Route as LoginIndexImport } from './routes/login/index'
import { Route as SiteIndexImport } from './routes/_site/index'
import { Route as LoginAuthorizeImport } from './routes/login/authorize'
import { Route as SiteVerifyEmailImport } from './routes/_site/verify-email'
import { Route as SiteReportImport } from './routes/_site/report'
import { Route as SiteRecoverPasswordImport } from './routes/_site/recover-password'
import { Route as SiteChangePasswordImport } from './routes/_site/change-password'
import { Route as SiteUsersRouteImport } from './routes/_site/users/route'
import { Route as SiteMessagesRouteImport } from './routes/_site/messages/route'
import { Route as SiteCwgRouteImport } from './routes/_site/cwg/route'
import { Route as SiteAdminRouteImport } from './routes/_site/admin/route'
import { Route as SiteMessagesIndexImport } from './routes/_site/messages/index'
import { Route as SiteApplicationsIndexImport } from './routes/_site/applications/index'
import { Route as SiteAdminIndexImport } from './routes/_site/admin/index'
import { Route as SiteUsersStatsoffersImport } from './routes/_site/users/stats_offers'
import { Route as SiteUsersStatsImport } from './routes/_site/users/stats'
import { Route as SiteUsersProfileImport } from './routes/_site/users/profile'
import { Route as SiteNewsArchiveImport } from './routes/_site/news/archive'
import { Route as SiteMessagesNewImport } from './routes/_site/messages/new'
import { Route as SiteMessagesThreadIdImport } from './routes/_site/messages/$threadId'
import { Route as SiteCwgOwnImport } from './routes/_site/cwg/own'
import { Route as SiteCwgEntryImport } from './routes/_site/cwg/entry'
import { Route as SiteCwgMainApiImport } from './routes/_site/cwg-main/api'
import { Route as SiteCwgCollectionTagsImport } from './routes/_site/cwg-collection/tags'
import { Route as SiteCwgCollectionDuplicatesImport } from './routes/_site/cwg-collection/duplicates'
import { Route as SiteApplicationsRegisterImport } from './routes/_site/applications/register'
import { Route as SiteApplicationsClientIdImport } from './routes/_site/applications/$clientId'
import { Route as SiteUsersPublicprofileRouteImport } from './routes/_site/users/_public_profile/route'
import { Route as SiteCwgSearchRouteImport } from './routes/_site/cwg/search/route'
import { Route as SiteCwgBrowseRouteImport } from './routes/_site/cwg/browse/route'
import { Route as SiteCwgCollectionBrowseRouteImport } from './routes/_site/cwg-collection/browse/route'
import { Route as SiteNewsIndexIdImport } from './routes/_site/news/index.$id'
import { Route as SiteUsersSearchIndexImport } from './routes/_site/users/search/index'
import { Route as SiteCwgSearchIndexImport } from './routes/_site/cwg/search/index'
import { Route as SiteCwgBrowseIndexImport } from './routes/_site/cwg/browse/index'
import { Route as SiteCwgCollectionBrowseIndexImport } from './routes/_site/cwg-collection/browse/index'
import { Route as SiteAdminUsersIndexImport } from './routes/_site/admin/users/index'
import { Route as SiteAdminNewsIndexImport } from './routes/_site/admin/news/index'
import { Route as SiteAdminGroupsIndexImport } from './routes/_site/admin/groups/index'
import { Route as SiteUsersSearchUsernameImport } from './routes/_site/users/search/$username'
import { Route as SiteCwgSearchQueryImport } from './routes/_site/cwg/search/$query'
import { Route as SiteCwgModifyXwgIdImport } from './routes/_site/cwg/modify.$xwgId'
import { Route as SiteCwgCollectionBrowseAllImport } from './routes/_site/cwg-collection/browse/all'
import { Route as SiteAdminNewsCreateImport } from './routes/_site/admin/news/create'
import { Route as SiteAdminGroupsCreateImport } from './routes/_site/admin/groups/create'
import { Route as SiteCwgBrowseAdvancedRouteImport } from './routes/_site/cwg/browse/advanced/route'
import { Route as SiteCwgBrowsePrimarySortingRouteImport } from './routes/_site/cwg/browse/$primarySorting/route'
import { Route as SiteCwgCollectionBrowsePrimarySortingRouteImport } from './routes/_site/cwg-collection/browse/$primarySorting/route'
import { Route as SiteAdminApprovingQueueRouteImport } from './routes/_site/admin/approving/_queue/route'
import { Route as SiteUsersPublicprofileIndexUsernameImport } from './routes/_site/users/_public_profile/index.$username'
import { Route as SiteCwgIndexXwgIdJoinImport } from './routes/_site/cwg/index.$xwgId/join'
import { Route as SiteCwgIndexXwgIdImagesImport } from './routes/_site/cwg/index.$xwgId/images'
import { Route as SiteCwgIndexXwgIdIndexImport } from './routes/_site/cwg/index.$xwgId/index'
import { Route as SiteCwgBrowseAdvancedIndexImport } from './routes/_site/cwg/browse/advanced/index'
import { Route as SiteCwgBrowsePrimarySortingIndexImport } from './routes/_site/cwg/browse/$primarySorting/index'
import { Route as SiteCwgCollectionBrowsePrimarySortingIndexImport } from './routes/_site/cwg-collection/browse/$primarySorting/index'
import { Route as SiteAdminApprovingQueueIndexImport } from './routes/_site/admin/approving/_queue/index'
import { Route as SiteUsersPublicprofileMessagesUsernameImport } from './routes/_site/users/_public_profile/messages.$username'
import { Route as SiteCwgBrowseAdvancedFilterImport } from './routes/_site/cwg/browse/advanced/$filter'
import { Route as SiteAdminUsersUserIdPrivilegesImport } from './routes/_site/admin/users/$userId.privileges'
import { Route as SiteAdminUsersUserIdGroupsImport } from './routes/_site/admin/users/$userId.groups'
import { Route as SiteAdminNewsModifyIdImport } from './routes/_site/admin/news/modify.$id'
import { Route as SiteAdminGroupsGroupIdModifyImport } from './routes/_site/admin/groups/$groupId.modify'
import { Route as SiteAdminApprovingQueueHoldsImport } from './routes/_site/admin/approving/_queue/holds'
import { Route as SiteAdminApprovingQueueAllImport } from './routes/_site/admin/approving/_queue/all'
import { Route as SiteUsersPublicprofileWantsUsernameRouteImport } from './routes/_site/users/_public_profile/wants.$username/route'
import { Route as SiteUsersPublicprofileOffersUsernameRouteImport } from './routes/_site/users/_public_profile/offers.$username/route'
import { Route as SiteUsersPublicprofileNotwantUsernameRouteImport } from './routes/_site/users/_public_profile/notwant.$username/route'
import { Route as SiteUsersPublicprofileCollectionUsernameRouteImport } from './routes/_site/users/_public_profile/collection.$username/route'
import { Route as SiteCwgBrowsePrimarySortingPrimaryCategoryNameRouteImport } from './routes/_site/cwg/browse/$primarySorting/$primaryCategoryName/route'
import { Route as SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameRouteImport } from './routes/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/route'
import { Route as SiteUsersPublicprofileWantsUsernameIndexImport } from './routes/_site/users/_public_profile/wants.$username/index'
import { Route as SiteUsersPublicprofileOffersUsernameIndexImport } from './routes/_site/users/_public_profile/offers.$username/index'
import { Route as SiteUsersPublicprofileNotwantUsernameIndexImport } from './routes/_site/users/_public_profile/notwant.$username/index'
import { Route as SiteUsersPublicprofileCollectionUsernameIndexImport } from './routes/_site/users/_public_profile/collection.$username/index'
import { Route as SiteCwgBrowsePrimarySortingPrimaryCategoryNameIndexImport } from './routes/_site/cwg/browse/$primarySorting/$primaryCategoryName/index'
import { Route as SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameIndexImport } from './routes/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/index'
import { Route as SiteUsersPublicprofileWantsUsernameAllImport } from './routes/_site/users/_public_profile/wants.$username/all'
import { Route as SiteUsersPublicprofileOffersUsernameAllImport } from './routes/_site/users/_public_profile/offers.$username/all'
import { Route as SiteUsersPublicprofileNotwantUsernameAllImport } from './routes/_site/users/_public_profile/notwant.$username/all'
import { Route as SiteUsersPublicprofileCollectionUsernameAllImport } from './routes/_site/users/_public_profile/collection.$username/all'
import { Route as SiteUsersPublicprofileWantsUsernamePrimarySortingRouteImport } from './routes/_site/users/_public_profile/wants.$username/$primarySorting/route'
import { Route as SiteUsersPublicprofileOffersUsernamePrimarySortingRouteImport } from './routes/_site/users/_public_profile/offers.$username/$primarySorting/route'
import { Route as SiteUsersPublicprofileNotwantUsernamePrimarySortingRouteImport } from './routes/_site/users/_public_profile/notwant.$username/$primarySorting/route'
import { Route as SiteUsersPublicprofileCollectionUsernamePrimarySortingRouteImport } from './routes/_site/users/_public_profile/collection.$username/$primarySorting/route'
import { Route as SiteCwgBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteImport } from './routes/_site/cwg/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName/route'
import { Route as SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameAllRouteImport } from './routes/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/all/route'
import { Route as SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteImport } from './routes/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName/route'
import { Route as SiteUsersPublicprofileWantsUsernamePrimarySortingIndexImport } from './routes/_site/users/_public_profile/wants.$username/$primarySorting/index'
import { Route as SiteUsersPublicprofileOffersUsernamePrimarySortingIndexImport } from './routes/_site/users/_public_profile/offers.$username/$primarySorting/index'
import { Route as SiteUsersPublicprofileNotwantUsernamePrimarySortingIndexImport } from './routes/_site/users/_public_profile/notwant.$username/$primarySorting/index'
import { Route as SiteUsersPublicprofileCollectionUsernamePrimarySortingIndexImport } from './routes/_site/users/_public_profile/collection.$username/$primarySorting/index'
import { Route as SiteCwgBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexImport } from './routes/_site/cwg/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName/index'
import { Route as SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameAllIndexImport } from './routes/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/all/index'
import { Route as SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexImport } from './routes/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName/index'
import { Route as SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameRouteImport } from './routes/_site/users/_public_profile/wants.$username/$primarySorting/$primaryCategoryName/route'
import { Route as SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameRouteImport } from './routes/_site/users/_public_profile/offers.$username/$primarySorting/$primaryCategoryName/route'
import { Route as SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameRouteImport } from './routes/_site/users/_public_profile/notwant.$username/$primarySorting/$primaryCategoryName/route'
import { Route as SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameRouteImport } from './routes/_site/users/_public_profile/collection.$username/$primarySorting/$primaryCategoryName/route'
import { Route as SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameIndexImport } from './routes/_site/users/_public_profile/wants.$username/$primarySorting/$primaryCategoryName/index'
import { Route as SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameIndexImport } from './routes/_site/users/_public_profile/offers.$username/$primarySorting/$primaryCategoryName/index'
import { Route as SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameIndexImport } from './routes/_site/users/_public_profile/notwant.$username/$primarySorting/$primaryCategoryName/index'
import { Route as SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameIndexImport } from './routes/_site/users/_public_profile/collection.$username/$primarySorting/$primaryCategoryName/index'
import { Route as SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameAllRouteImport } from './routes/_site/users/_public_profile/wants.$username/$primarySorting/$primaryCategoryName/all/route'
import { Route as SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteImport } from './routes/_site/users/_public_profile/wants.$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/route'
import { Route as SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameAllRouteImport } from './routes/_site/users/_public_profile/offers.$username/$primarySorting/$primaryCategoryName/all/route'
import { Route as SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteImport } from './routes/_site/users/_public_profile/offers.$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/route'
import { Route as SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameAllRouteImport } from './routes/_site/users/_public_profile/notwant.$username/$primarySorting/$primaryCategoryName/all/route'
import { Route as SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteImport } from './routes/_site/users/_public_profile/notwant.$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/route'
import { Route as SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameAllRouteImport } from './routes/_site/users/_public_profile/collection.$username/$primarySorting/$primaryCategoryName/all/route'
import { Route as SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteImport } from './routes/_site/users/_public_profile/collection.$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/route'
import { Route as SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameAllIndexImport } from './routes/_site/users/_public_profile/wants.$username/$primarySorting/$primaryCategoryName/all/index'
import { Route as SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexImport } from './routes/_site/users/_public_profile/wants.$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/index'
import { Route as SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameAllIndexImport } from './routes/_site/users/_public_profile/offers.$username/$primarySorting/$primaryCategoryName/all/index'
import { Route as SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexImport } from './routes/_site/users/_public_profile/offers.$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/index'
import { Route as SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameAllIndexImport } from './routes/_site/users/_public_profile/notwant.$username/$primarySorting/$primaryCategoryName/all/index'
import { Route as SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexImport } from './routes/_site/users/_public_profile/notwant.$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/index'
import { Route as SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameAllIndexImport } from './routes/_site/users/_public_profile/collection.$username/$primarySorting/$primaryCategoryName/all/index'
import { Route as SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexImport } from './routes/_site/users/_public_profile/collection.$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/index'

// Create Virtual Routes

const SiteAdminApprovingImport = createFileRoute('/_site/admin/approving')()

// Create/Update Routes

const LoginRouteRoute = LoginRouteImport.update({
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const SiteRouteRoute = SiteRouteImport.update({
  id: '/_site',
  getParentRoute: () => rootRoute,
} as any)

const LoginIndexRoute = LoginIndexImport.update({
  path: '/',
  getParentRoute: () => LoginRouteRoute,
} as any)

const SiteIndexRoute = SiteIndexImport.update({
  path: '/',
  getParentRoute: () => SiteRouteRoute,
} as any)

const LoginAuthorizeRoute = LoginAuthorizeImport.update({
  path: '/authorize',
  getParentRoute: () => LoginRouteRoute,
} as any)

const SiteVerifyEmailRoute = SiteVerifyEmailImport.update({
  path: '/verify-email',
  getParentRoute: () => SiteRouteRoute,
} as any)

const SiteReportRoute = SiteReportImport.update({
  path: '/report',
  getParentRoute: () => SiteRouteRoute,
} as any)

const SiteRecoverPasswordRoute = SiteRecoverPasswordImport.update({
  path: '/recover-password',
  getParentRoute: () => SiteRouteRoute,
} as any)

const SiteChangePasswordRoute = SiteChangePasswordImport.update({
  path: '/change-password',
  getParentRoute: () => SiteRouteRoute,
} as any)

const SiteUsersRouteRoute = SiteUsersRouteImport.update({
  path: '/users',
  getParentRoute: () => SiteRouteRoute,
} as any)

const SiteMessagesRouteRoute = SiteMessagesRouteImport.update({
  path: '/messages',
  getParentRoute: () => SiteRouteRoute,
} as any)

const SiteCwgRouteRoute = SiteCwgRouteImport.update({
  path: '/cwg',
  getParentRoute: () => SiteRouteRoute,
} as any)

const SiteAdminRouteRoute = SiteAdminRouteImport.update({
  path: '/admin',
  getParentRoute: () => SiteRouteRoute,
} as any)

const SiteAdminApprovingRoute = SiteAdminApprovingImport.update({
  path: '/approving',
  getParentRoute: () => SiteAdminRouteRoute,
} as any)

const SiteMessagesIndexRoute = SiteMessagesIndexImport.update({
  path: '/',
  getParentRoute: () => SiteMessagesRouteRoute,
} as any)

const SiteApplicationsIndexRoute = SiteApplicationsIndexImport.update({
  path: '/applications/',
  getParentRoute: () => SiteRouteRoute,
} as any)

const SiteAdminIndexRoute = SiteAdminIndexImport.update({
  path: '/',
  getParentRoute: () => SiteAdminRouteRoute,
} as any)

const SiteUsersStatsoffersRoute = SiteUsersStatsoffersImport.update({
  path: '/stats_offers',
  getParentRoute: () => SiteUsersRouteRoute,
} as any)

const SiteUsersStatsRoute = SiteUsersStatsImport.update({
  path: '/stats',
  getParentRoute: () => SiteUsersRouteRoute,
} as any)

const SiteUsersProfileRoute = SiteUsersProfileImport.update({
  path: '/profile',
  getParentRoute: () => SiteUsersRouteRoute,
} as any)

const SiteNewsArchiveRoute = SiteNewsArchiveImport.update({
  path: '/news/archive',
  getParentRoute: () => SiteRouteRoute,
} as any)

const SiteMessagesNewRoute = SiteMessagesNewImport.update({
  path: '/new',
  getParentRoute: () => SiteMessagesRouteRoute,
} as any)

const SiteMessagesThreadIdRoute = SiteMessagesThreadIdImport.update({
  path: '/$threadId',
  getParentRoute: () => SiteMessagesRouteRoute,
} as any)

const SiteCwgOwnRoute = SiteCwgOwnImport.update({
  path: '/own',
  getParentRoute: () => SiteCwgRouteRoute,
} as any)

const SiteCwgEntryRoute = SiteCwgEntryImport.update({
  path: '/entry',
  getParentRoute: () => SiteCwgRouteRoute,
} as any)

const SiteCwgMainApiRoute = SiteCwgMainApiImport.update({
  path: '/cwg-main/api',
  getParentRoute: () => SiteRouteRoute,
} as any)

const SiteCwgCollectionTagsRoute = SiteCwgCollectionTagsImport.update({
  path: '/cwg-collection/tags',
  getParentRoute: () => SiteRouteRoute,
} as any)

const SiteCwgCollectionDuplicatesRoute =
  SiteCwgCollectionDuplicatesImport.update({
    path: '/cwg-collection/duplicates',
    getParentRoute: () => SiteRouteRoute,
  } as any)

const SiteApplicationsRegisterRoute = SiteApplicationsRegisterImport.update({
  path: '/applications/register',
  getParentRoute: () => SiteRouteRoute,
} as any)

const SiteApplicationsClientIdRoute = SiteApplicationsClientIdImport.update({
  path: '/applications/$clientId',
  getParentRoute: () => SiteRouteRoute,
} as any)

const SiteUsersPublicprofileRouteRoute =
  SiteUsersPublicprofileRouteImport.update({
    id: '/_public_profile',
    getParentRoute: () => SiteUsersRouteRoute,
  } as any)

const SiteCwgSearchRouteRoute = SiteCwgSearchRouteImport.update({
  path: '/search',
  getParentRoute: () => SiteCwgRouteRoute,
} as any)

const SiteCwgBrowseRouteRoute = SiteCwgBrowseRouteImport.update({
  path: '/browse',
  getParentRoute: () => SiteCwgRouteRoute,
} as any)

const SiteCwgCollectionBrowseRouteRoute =
  SiteCwgCollectionBrowseRouteImport.update({
    path: '/cwg-collection/browse',
    getParentRoute: () => SiteRouteRoute,
  } as any)

const SiteNewsIndexIdRoute = SiteNewsIndexIdImport.update({
  path: '/news/index/$id',
  getParentRoute: () => SiteRouteRoute,
} as any)

const SiteUsersSearchIndexRoute = SiteUsersSearchIndexImport.update({
  path: '/search/',
  getParentRoute: () => SiteUsersRouteRoute,
} as any)

const SiteCwgSearchIndexRoute = SiteCwgSearchIndexImport.update({
  path: '/',
  getParentRoute: () => SiteCwgSearchRouteRoute,
} as any)

const SiteCwgBrowseIndexRoute = SiteCwgBrowseIndexImport.update({
  path: '/',
  getParentRoute: () => SiteCwgBrowseRouteRoute,
} as any)

const SiteCwgCollectionBrowseIndexRoute =
  SiteCwgCollectionBrowseIndexImport.update({
    path: '/',
    getParentRoute: () => SiteCwgCollectionBrowseRouteRoute,
  } as any)

const SiteAdminUsersIndexRoute = SiteAdminUsersIndexImport.update({
  path: '/users/',
  getParentRoute: () => SiteAdminRouteRoute,
} as any)

const SiteAdminNewsIndexRoute = SiteAdminNewsIndexImport.update({
  path: '/news/',
  getParentRoute: () => SiteAdminRouteRoute,
} as any)

const SiteAdminGroupsIndexRoute = SiteAdminGroupsIndexImport.update({
  path: '/groups/',
  getParentRoute: () => SiteAdminRouteRoute,
} as any)

const SiteUsersSearchUsernameRoute = SiteUsersSearchUsernameImport.update({
  path: '/search/$username',
  getParentRoute: () => SiteUsersRouteRoute,
} as any)

const SiteCwgSearchQueryRoute = SiteCwgSearchQueryImport.update({
  path: '/$query',
  getParentRoute: () => SiteCwgSearchRouteRoute,
} as any)

const SiteCwgModifyXwgIdRoute = SiteCwgModifyXwgIdImport.update({
  path: '/modify/$xwgId',
  getParentRoute: () => SiteCwgRouteRoute,
} as any)

const SiteCwgCollectionBrowseAllRoute = SiteCwgCollectionBrowseAllImport.update(
  {
    path: '/all',
    getParentRoute: () => SiteCwgCollectionBrowseRouteRoute,
  } as any,
)

const SiteAdminNewsCreateRoute = SiteAdminNewsCreateImport.update({
  path: '/news/create',
  getParentRoute: () => SiteAdminRouteRoute,
} as any)

const SiteAdminGroupsCreateRoute = SiteAdminGroupsCreateImport.update({
  path: '/groups/create',
  getParentRoute: () => SiteAdminRouteRoute,
} as any)

const SiteCwgBrowseAdvancedRouteRoute = SiteCwgBrowseAdvancedRouteImport.update(
  {
    path: '/advanced',
    getParentRoute: () => SiteCwgBrowseRouteRoute,
  } as any,
)

const SiteCwgBrowsePrimarySortingRouteRoute =
  SiteCwgBrowsePrimarySortingRouteImport.update({
    path: '/$primarySorting',
    getParentRoute: () => SiteCwgBrowseRouteRoute,
  } as any)

const SiteCwgCollectionBrowsePrimarySortingRouteRoute =
  SiteCwgCollectionBrowsePrimarySortingRouteImport.update({
    path: '/$primarySorting',
    getParentRoute: () => SiteCwgCollectionBrowseRouteRoute,
  } as any)

const SiteAdminApprovingQueueRouteRoute =
  SiteAdminApprovingQueueRouteImport.update({
    id: '/approving/_queue',
    getParentRoute: () => SiteAdminApprovingRoute,
  } as any)

const SiteUsersPublicprofileIndexUsernameRoute =
  SiteUsersPublicprofileIndexUsernameImport.update({
    path: '/index/$username',
    getParentRoute: () => SiteUsersPublicprofileRouteRoute,
  } as any)

const SiteCwgIndexXwgIdJoinRoute = SiteCwgIndexXwgIdJoinImport.update({
  path: '/index/$xwgId/join',
  getParentRoute: () => SiteCwgRouteRoute,
} as any)

const SiteCwgIndexXwgIdImagesRoute = SiteCwgIndexXwgIdImagesImport.update({
  path: '/index/$xwgId/images',
  getParentRoute: () => SiteCwgRouteRoute,
} as any)

const SiteCwgIndexXwgIdIndexRoute = SiteCwgIndexXwgIdIndexImport.update({
  path: '/index/$xwgId/',
  getParentRoute: () => SiteCwgRouteRoute,
} as any)

const SiteCwgBrowseAdvancedIndexRoute = SiteCwgBrowseAdvancedIndexImport.update(
  {
    path: '/',
    getParentRoute: () => SiteCwgBrowseAdvancedRouteRoute,
  } as any,
)

const SiteCwgBrowsePrimarySortingIndexRoute =
  SiteCwgBrowsePrimarySortingIndexImport.update({
    path: '/',
    getParentRoute: () => SiteCwgBrowsePrimarySortingRouteRoute,
  } as any)

const SiteCwgCollectionBrowsePrimarySortingIndexRoute =
  SiteCwgCollectionBrowsePrimarySortingIndexImport.update({
    path: '/',
    getParentRoute: () => SiteCwgCollectionBrowsePrimarySortingRouteRoute,
  } as any)

const SiteAdminApprovingQueueIndexRoute =
  SiteAdminApprovingQueueIndexImport.update({
    path: '/',
    getParentRoute: () => SiteAdminApprovingQueueRouteRoute,
  } as any)

const SiteUsersPublicprofileMessagesUsernameRoute =
  SiteUsersPublicprofileMessagesUsernameImport.update({
    path: '/messages/$username',
    getParentRoute: () => SiteUsersPublicprofileRouteRoute,
  } as any)

const SiteCwgBrowseAdvancedFilterRoute =
  SiteCwgBrowseAdvancedFilterImport.update({
    path: '/$filter',
    getParentRoute: () => SiteCwgBrowseAdvancedRouteRoute,
  } as any)

const SiteAdminUsersUserIdPrivilegesRoute =
  SiteAdminUsersUserIdPrivilegesImport.update({
    path: '/users/$userId/privileges',
    getParentRoute: () => SiteAdminRouteRoute,
  } as any)

const SiteAdminUsersUserIdGroupsRoute = SiteAdminUsersUserIdGroupsImport.update(
  {
    path: '/users/$userId/groups',
    getParentRoute: () => SiteAdminRouteRoute,
  } as any,
)

const SiteAdminNewsModifyIdRoute = SiteAdminNewsModifyIdImport.update({
  path: '/news/modify/$id',
  getParentRoute: () => SiteAdminRouteRoute,
} as any)

const SiteAdminGroupsGroupIdModifyRoute =
  SiteAdminGroupsGroupIdModifyImport.update({
    path: '/groups/$groupId/modify',
    getParentRoute: () => SiteAdminRouteRoute,
  } as any)

const SiteAdminApprovingQueueHoldsRoute =
  SiteAdminApprovingQueueHoldsImport.update({
    path: '/holds',
    getParentRoute: () => SiteAdminApprovingQueueRouteRoute,
  } as any)

const SiteAdminApprovingQueueAllRoute = SiteAdminApprovingQueueAllImport.update(
  {
    path: '/all',
    getParentRoute: () => SiteAdminApprovingQueueRouteRoute,
  } as any,
)

const SiteUsersPublicprofileWantsUsernameRouteRoute =
  SiteUsersPublicprofileWantsUsernameRouteImport.update({
    path: '/wants/$username',
    getParentRoute: () => SiteUsersPublicprofileRouteRoute,
  } as any)

const SiteUsersPublicprofileOffersUsernameRouteRoute =
  SiteUsersPublicprofileOffersUsernameRouteImport.update({
    path: '/offers/$username',
    getParentRoute: () => SiteUsersPublicprofileRouteRoute,
  } as any)

const SiteUsersPublicprofileNotwantUsernameRouteRoute =
  SiteUsersPublicprofileNotwantUsernameRouteImport.update({
    path: '/notwant/$username',
    getParentRoute: () => SiteUsersPublicprofileRouteRoute,
  } as any)

const SiteUsersPublicprofileCollectionUsernameRouteRoute =
  SiteUsersPublicprofileCollectionUsernameRouteImport.update({
    path: '/collection/$username',
    getParentRoute: () => SiteUsersPublicprofileRouteRoute,
  } as any)

const SiteCwgBrowsePrimarySortingPrimaryCategoryNameRouteRoute =
  SiteCwgBrowsePrimarySortingPrimaryCategoryNameRouteImport.update({
    path: '/$primaryCategoryName',
    getParentRoute: () => SiteCwgBrowsePrimarySortingRouteRoute,
  } as any)

const SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameRouteRoute =
  SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameRouteImport.update({
    path: '/$primaryCategoryName',
    getParentRoute: () => SiteCwgCollectionBrowsePrimarySortingRouteRoute,
  } as any)

const SiteUsersPublicprofileWantsUsernameIndexRoute =
  SiteUsersPublicprofileWantsUsernameIndexImport.update({
    path: '/',
    getParentRoute: () => SiteUsersPublicprofileWantsUsernameRouteRoute,
  } as any)

const SiteUsersPublicprofileOffersUsernameIndexRoute =
  SiteUsersPublicprofileOffersUsernameIndexImport.update({
    path: '/',
    getParentRoute: () => SiteUsersPublicprofileOffersUsernameRouteRoute,
  } as any)

const SiteUsersPublicprofileNotwantUsernameIndexRoute =
  SiteUsersPublicprofileNotwantUsernameIndexImport.update({
    path: '/',
    getParentRoute: () => SiteUsersPublicprofileNotwantUsernameRouteRoute,
  } as any)

const SiteUsersPublicprofileCollectionUsernameIndexRoute =
  SiteUsersPublicprofileCollectionUsernameIndexImport.update({
    path: '/',
    getParentRoute: () => SiteUsersPublicprofileCollectionUsernameRouteRoute,
  } as any)

const SiteCwgBrowsePrimarySortingPrimaryCategoryNameIndexRoute =
  SiteCwgBrowsePrimarySortingPrimaryCategoryNameIndexImport.update({
    path: '/',
    getParentRoute: () =>
      SiteCwgBrowsePrimarySortingPrimaryCategoryNameRouteRoute,
  } as any)

const SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameIndexRoute =
  SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameIndexImport.update({
    path: '/',
    getParentRoute: () =>
      SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameRouteRoute,
  } as any)

const SiteUsersPublicprofileWantsUsernameAllRoute =
  SiteUsersPublicprofileWantsUsernameAllImport.update({
    path: '/all',
    getParentRoute: () => SiteUsersPublicprofileWantsUsernameRouteRoute,
  } as any)

const SiteUsersPublicprofileOffersUsernameAllRoute =
  SiteUsersPublicprofileOffersUsernameAllImport.update({
    path: '/all',
    getParentRoute: () => SiteUsersPublicprofileOffersUsernameRouteRoute,
  } as any)

const SiteUsersPublicprofileNotwantUsernameAllRoute =
  SiteUsersPublicprofileNotwantUsernameAllImport.update({
    path: '/all',
    getParentRoute: () => SiteUsersPublicprofileNotwantUsernameRouteRoute,
  } as any)

const SiteUsersPublicprofileCollectionUsernameAllRoute =
  SiteUsersPublicprofileCollectionUsernameAllImport.update({
    path: '/all',
    getParentRoute: () => SiteUsersPublicprofileCollectionUsernameRouteRoute,
  } as any)

const SiteUsersPublicprofileWantsUsernamePrimarySortingRouteRoute =
  SiteUsersPublicprofileWantsUsernamePrimarySortingRouteImport.update({
    path: '/$primarySorting',
    getParentRoute: () => SiteUsersPublicprofileWantsUsernameRouteRoute,
  } as any)

const SiteUsersPublicprofileOffersUsernamePrimarySortingRouteRoute =
  SiteUsersPublicprofileOffersUsernamePrimarySortingRouteImport.update({
    path: '/$primarySorting',
    getParentRoute: () => SiteUsersPublicprofileOffersUsernameRouteRoute,
  } as any)

const SiteUsersPublicprofileNotwantUsernamePrimarySortingRouteRoute =
  SiteUsersPublicprofileNotwantUsernamePrimarySortingRouteImport.update({
    path: '/$primarySorting',
    getParentRoute: () => SiteUsersPublicprofileNotwantUsernameRouteRoute,
  } as any)

const SiteUsersPublicprofileCollectionUsernamePrimarySortingRouteRoute =
  SiteUsersPublicprofileCollectionUsernamePrimarySortingRouteImport.update({
    path: '/$primarySorting',
    getParentRoute: () => SiteUsersPublicprofileCollectionUsernameRouteRoute,
  } as any)

const SiteCwgBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRoute =
  SiteCwgBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteImport.update(
    {
      path: '/$secondaryCategoryName',
      getParentRoute: () =>
        SiteCwgBrowsePrimarySortingPrimaryCategoryNameRouteRoute,
    } as any,
  )

const SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameAllRouteRoute =
  SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameAllRouteImport.update(
    {
      path: '/all',
      getParentRoute: () =>
        SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameRouteRoute,
    } as any,
  )

const SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRoute =
  SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteImport.update(
    {
      path: '/$secondaryCategoryName',
      getParentRoute: () =>
        SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameRouteRoute,
    } as any,
  )

const SiteUsersPublicprofileWantsUsernamePrimarySortingIndexRoute =
  SiteUsersPublicprofileWantsUsernamePrimarySortingIndexImport.update({
    path: '/',
    getParentRoute: () =>
      SiteUsersPublicprofileWantsUsernamePrimarySortingRouteRoute,
  } as any)

const SiteUsersPublicprofileOffersUsernamePrimarySortingIndexRoute =
  SiteUsersPublicprofileOffersUsernamePrimarySortingIndexImport.update({
    path: '/',
    getParentRoute: () =>
      SiteUsersPublicprofileOffersUsernamePrimarySortingRouteRoute,
  } as any)

const SiteUsersPublicprofileNotwantUsernamePrimarySortingIndexRoute =
  SiteUsersPublicprofileNotwantUsernamePrimarySortingIndexImport.update({
    path: '/',
    getParentRoute: () =>
      SiteUsersPublicprofileNotwantUsernamePrimarySortingRouteRoute,
  } as any)

const SiteUsersPublicprofileCollectionUsernamePrimarySortingIndexRoute =
  SiteUsersPublicprofileCollectionUsernamePrimarySortingIndexImport.update({
    path: '/',
    getParentRoute: () =>
      SiteUsersPublicprofileCollectionUsernamePrimarySortingRouteRoute,
  } as any)

const SiteCwgBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute =
  SiteCwgBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexImport.update(
    {
      path: '/',
      getParentRoute: () =>
        SiteCwgBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRoute,
    } as any,
  )

const SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameAllIndexRoute =
  SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameAllIndexImport.update(
    {
      path: '/',
      getParentRoute: () =>
        SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameAllRouteRoute,
    } as any,
  )

const SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute =
  SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexImport.update(
    {
      path: '/',
      getParentRoute: () =>
        SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRoute,
    } as any,
  )

const SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameRouteRoute =
  SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameRouteImport.update(
    {
      path: '/$primaryCategoryName',
      getParentRoute: () =>
        SiteUsersPublicprofileWantsUsernamePrimarySortingRouteRoute,
    } as any,
  )

const SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameRouteRoute =
  SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameRouteImport.update(
    {
      path: '/$primaryCategoryName',
      getParentRoute: () =>
        SiteUsersPublicprofileOffersUsernamePrimarySortingRouteRoute,
    } as any,
  )

const SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameRouteRoute =
  SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameRouteImport.update(
    {
      path: '/$primaryCategoryName',
      getParentRoute: () =>
        SiteUsersPublicprofileNotwantUsernamePrimarySortingRouteRoute,
    } as any,
  )

const SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameRouteRoute =
  SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameRouteImport.update(
    {
      path: '/$primaryCategoryName',
      getParentRoute: () =>
        SiteUsersPublicprofileCollectionUsernamePrimarySortingRouteRoute,
    } as any,
  )

const SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameIndexRoute =
  SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameIndexImport.update(
    {
      path: '/',
      getParentRoute: () =>
        SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameRouteRoute,
    } as any,
  )

const SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameIndexRoute =
  SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameIndexImport.update(
    {
      path: '/',
      getParentRoute: () =>
        SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameRouteRoute,
    } as any,
  )

const SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameIndexRoute =
  SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameIndexImport.update(
    {
      path: '/',
      getParentRoute: () =>
        SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameRouteRoute,
    } as any,
  )

const SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameIndexRoute =
  SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameIndexImport.update(
    {
      path: '/',
      getParentRoute: () =>
        SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameRouteRoute,
    } as any,
  )

const SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameAllRouteRoute =
  SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameAllRouteImport.update(
    {
      path: '/all',
      getParentRoute: () =>
        SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameRouteRoute,
    } as any,
  )

const SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRoute =
  SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteImport.update(
    {
      path: '/$secondaryCategoryName',
      getParentRoute: () =>
        SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameRouteRoute,
    } as any,
  )

const SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameAllRouteRoute =
  SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameAllRouteImport.update(
    {
      path: '/all',
      getParentRoute: () =>
        SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameRouteRoute,
    } as any,
  )

const SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRoute =
  SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteImport.update(
    {
      path: '/$secondaryCategoryName',
      getParentRoute: () =>
        SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameRouteRoute,
    } as any,
  )

const SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameAllRouteRoute =
  SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameAllRouteImport.update(
    {
      path: '/all',
      getParentRoute: () =>
        SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameRouteRoute,
    } as any,
  )

const SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRoute =
  SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteImport.update(
    {
      path: '/$secondaryCategoryName',
      getParentRoute: () =>
        SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameRouteRoute,
    } as any,
  )

const SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameAllRouteRoute =
  SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameAllRouteImport.update(
    {
      path: '/all',
      getParentRoute: () =>
        SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameRouteRoute,
    } as any,
  )

const SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRoute =
  SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteImport.update(
    {
      path: '/$secondaryCategoryName',
      getParentRoute: () =>
        SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameRouteRoute,
    } as any,
  )

const SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameAllIndexRoute =
  SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameAllIndexImport.update(
    {
      path: '/',
      getParentRoute: () =>
        SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameAllRouteRoute,
    } as any,
  )

const SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute =
  SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexImport.update(
    {
      path: '/',
      getParentRoute: () =>
        SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRoute,
    } as any,
  )

const SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameAllIndexRoute =
  SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameAllIndexImport.update(
    {
      path: '/',
      getParentRoute: () =>
        SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameAllRouteRoute,
    } as any,
  )

const SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute =
  SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexImport.update(
    {
      path: '/',
      getParentRoute: () =>
        SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRoute,
    } as any,
  )

const SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameAllIndexRoute =
  SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameAllIndexImport.update(
    {
      path: '/',
      getParentRoute: () =>
        SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameAllRouteRoute,
    } as any,
  )

const SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute =
  SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexImport.update(
    {
      path: '/',
      getParentRoute: () =>
        SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRoute,
    } as any,
  )

const SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameAllIndexRoute =
  SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameAllIndexImport.update(
    {
      path: '/',
      getParentRoute: () =>
        SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameAllRouteRoute,
    } as any,
  )

const SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute =
  SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexImport.update(
    {
      path: '/',
      getParentRoute: () =>
        SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRoute,
    } as any,
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_site': {
      id: '/_site'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof SiteRouteImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRoute
    }
    '/_site/admin': {
      id: '/_site/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof SiteAdminRouteImport
      parentRoute: typeof SiteRouteImport
    }
    '/_site/cwg': {
      id: '/_site/cwg'
      path: '/cwg'
      fullPath: '/cwg'
      preLoaderRoute: typeof SiteCwgRouteImport
      parentRoute: typeof SiteRouteImport
    }
    '/_site/messages': {
      id: '/_site/messages'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof SiteMessagesRouteImport
      parentRoute: typeof SiteRouteImport
    }
    '/_site/users': {
      id: '/_site/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof SiteUsersRouteImport
      parentRoute: typeof SiteRouteImport
    }
    '/_site/change-password': {
      id: '/_site/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof SiteChangePasswordImport
      parentRoute: typeof SiteRouteImport
    }
    '/_site/recover-password': {
      id: '/_site/recover-password'
      path: '/recover-password'
      fullPath: '/recover-password'
      preLoaderRoute: typeof SiteRecoverPasswordImport
      parentRoute: typeof SiteRouteImport
    }
    '/_site/report': {
      id: '/_site/report'
      path: '/report'
      fullPath: '/report'
      preLoaderRoute: typeof SiteReportImport
      parentRoute: typeof SiteRouteImport
    }
    '/_site/verify-email': {
      id: '/_site/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof SiteVerifyEmailImport
      parentRoute: typeof SiteRouteImport
    }
    '/login/authorize': {
      id: '/login/authorize'
      path: '/authorize'
      fullPath: '/login/authorize'
      preLoaderRoute: typeof LoginAuthorizeImport
      parentRoute: typeof LoginRouteImport
    }
    '/_site/': {
      id: '/_site/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof SiteIndexImport
      parentRoute: typeof SiteRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexImport
      parentRoute: typeof LoginRouteImport
    }
    '/_site/cwg-collection/browse': {
      id: '/_site/cwg-collection/browse'
      path: '/cwg-collection/browse'
      fullPath: '/cwg-collection/browse'
      preLoaderRoute: typeof SiteCwgCollectionBrowseRouteImport
      parentRoute: typeof SiteRouteImport
    }
    '/_site/cwg/browse': {
      id: '/_site/cwg/browse'
      path: '/browse'
      fullPath: '/cwg/browse'
      preLoaderRoute: typeof SiteCwgBrowseRouteImport
      parentRoute: typeof SiteCwgRouteImport
    }
    '/_site/cwg/search': {
      id: '/_site/cwg/search'
      path: '/search'
      fullPath: '/cwg/search'
      preLoaderRoute: typeof SiteCwgSearchRouteImport
      parentRoute: typeof SiteCwgRouteImport
    }
    '/_site/users/_public_profile': {
      id: '/_site/users/_public_profile'
      path: ''
      fullPath: '/users'
      preLoaderRoute: typeof SiteUsersPublicprofileRouteImport
      parentRoute: typeof SiteUsersRouteImport
    }
    '/_site/applications/$clientId': {
      id: '/_site/applications/$clientId'
      path: '/applications/$clientId'
      fullPath: '/applications/$clientId'
      preLoaderRoute: typeof SiteApplicationsClientIdImport
      parentRoute: typeof SiteRouteImport
    }
    '/_site/applications/register': {
      id: '/_site/applications/register'
      path: '/applications/register'
      fullPath: '/applications/register'
      preLoaderRoute: typeof SiteApplicationsRegisterImport
      parentRoute: typeof SiteRouteImport
    }
    '/_site/cwg-collection/duplicates': {
      id: '/_site/cwg-collection/duplicates'
      path: '/cwg-collection/duplicates'
      fullPath: '/cwg-collection/duplicates'
      preLoaderRoute: typeof SiteCwgCollectionDuplicatesImport
      parentRoute: typeof SiteRouteImport
    }
    '/_site/cwg-collection/tags': {
      id: '/_site/cwg-collection/tags'
      path: '/cwg-collection/tags'
      fullPath: '/cwg-collection/tags'
      preLoaderRoute: typeof SiteCwgCollectionTagsImport
      parentRoute: typeof SiteRouteImport
    }
    '/_site/cwg-main/api': {
      id: '/_site/cwg-main/api'
      path: '/cwg-main/api'
      fullPath: '/cwg-main/api'
      preLoaderRoute: typeof SiteCwgMainApiImport
      parentRoute: typeof SiteRouteImport
    }
    '/_site/cwg/entry': {
      id: '/_site/cwg/entry'
      path: '/entry'
      fullPath: '/cwg/entry'
      preLoaderRoute: typeof SiteCwgEntryImport
      parentRoute: typeof SiteCwgRouteImport
    }
    '/_site/cwg/own': {
      id: '/_site/cwg/own'
      path: '/own'
      fullPath: '/cwg/own'
      preLoaderRoute: typeof SiteCwgOwnImport
      parentRoute: typeof SiteCwgRouteImport
    }
    '/_site/messages/$threadId': {
      id: '/_site/messages/$threadId'
      path: '/$threadId'
      fullPath: '/messages/$threadId'
      preLoaderRoute: typeof SiteMessagesThreadIdImport
      parentRoute: typeof SiteMessagesRouteImport
    }
    '/_site/messages/new': {
      id: '/_site/messages/new'
      path: '/new'
      fullPath: '/messages/new'
      preLoaderRoute: typeof SiteMessagesNewImport
      parentRoute: typeof SiteMessagesRouteImport
    }
    '/_site/news/archive': {
      id: '/_site/news/archive'
      path: '/news/archive'
      fullPath: '/news/archive'
      preLoaderRoute: typeof SiteNewsArchiveImport
      parentRoute: typeof SiteRouteImport
    }
    '/_site/users/profile': {
      id: '/_site/users/profile'
      path: '/profile'
      fullPath: '/users/profile'
      preLoaderRoute: typeof SiteUsersProfileImport
      parentRoute: typeof SiteUsersRouteImport
    }
    '/_site/users/stats': {
      id: '/_site/users/stats'
      path: '/stats'
      fullPath: '/users/stats'
      preLoaderRoute: typeof SiteUsersStatsImport
      parentRoute: typeof SiteUsersRouteImport
    }
    '/_site/users/stats_offers': {
      id: '/_site/users/stats_offers'
      path: '/stats_offers'
      fullPath: '/users/stats_offers'
      preLoaderRoute: typeof SiteUsersStatsoffersImport
      parentRoute: typeof SiteUsersRouteImport
    }
    '/_site/admin/': {
      id: '/_site/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof SiteAdminIndexImport
      parentRoute: typeof SiteAdminRouteImport
    }
    '/_site/applications/': {
      id: '/_site/applications/'
      path: '/applications'
      fullPath: '/applications'
      preLoaderRoute: typeof SiteApplicationsIndexImport
      parentRoute: typeof SiteRouteImport
    }
    '/_site/messages/': {
      id: '/_site/messages/'
      path: '/'
      fullPath: '/messages/'
      preLoaderRoute: typeof SiteMessagesIndexImport
      parentRoute: typeof SiteMessagesRouteImport
    }
    '/_site/admin/approving': {
      id: '/_site/admin/approving'
      path: '/approving'
      fullPath: '/admin/approving'
      preLoaderRoute: typeof SiteAdminApprovingImport
      parentRoute: typeof SiteAdminRouteImport
    }
    '/_site/admin/approving/_queue': {
      id: '/_site/admin/approving/_queue'
      path: '/approving'
      fullPath: '/admin/approving'
      preLoaderRoute: typeof SiteAdminApprovingQueueRouteImport
      parentRoute: typeof SiteAdminApprovingRoute
    }
    '/_site/cwg-collection/browse/$primarySorting': {
      id: '/_site/cwg-collection/browse/$primarySorting'
      path: '/$primarySorting'
      fullPath: '/cwg-collection/browse/$primarySorting'
      preLoaderRoute: typeof SiteCwgCollectionBrowsePrimarySortingRouteImport
      parentRoute: typeof SiteCwgCollectionBrowseRouteImport
    }
    '/_site/cwg/browse/$primarySorting': {
      id: '/_site/cwg/browse/$primarySorting'
      path: '/$primarySorting'
      fullPath: '/cwg/browse/$primarySorting'
      preLoaderRoute: typeof SiteCwgBrowsePrimarySortingRouteImport
      parentRoute: typeof SiteCwgBrowseRouteImport
    }
    '/_site/cwg/browse/advanced': {
      id: '/_site/cwg/browse/advanced'
      path: '/advanced'
      fullPath: '/cwg/browse/advanced'
      preLoaderRoute: typeof SiteCwgBrowseAdvancedRouteImport
      parentRoute: typeof SiteCwgBrowseRouteImport
    }
    '/_site/admin/groups/create': {
      id: '/_site/admin/groups/create'
      path: '/groups/create'
      fullPath: '/admin/groups/create'
      preLoaderRoute: typeof SiteAdminGroupsCreateImport
      parentRoute: typeof SiteAdminRouteImport
    }
    '/_site/admin/news/create': {
      id: '/_site/admin/news/create'
      path: '/news/create'
      fullPath: '/admin/news/create'
      preLoaderRoute: typeof SiteAdminNewsCreateImport
      parentRoute: typeof SiteAdminRouteImport
    }
    '/_site/cwg-collection/browse/all': {
      id: '/_site/cwg-collection/browse/all'
      path: '/all'
      fullPath: '/cwg-collection/browse/all'
      preLoaderRoute: typeof SiteCwgCollectionBrowseAllImport
      parentRoute: typeof SiteCwgCollectionBrowseRouteImport
    }
    '/_site/cwg/modify/$xwgId': {
      id: '/_site/cwg/modify/$xwgId'
      path: '/modify/$xwgId'
      fullPath: '/cwg/modify/$xwgId'
      preLoaderRoute: typeof SiteCwgModifyXwgIdImport
      parentRoute: typeof SiteCwgRouteImport
    }
    '/_site/cwg/search/$query': {
      id: '/_site/cwg/search/$query'
      path: '/$query'
      fullPath: '/cwg/search/$query'
      preLoaderRoute: typeof SiteCwgSearchQueryImport
      parentRoute: typeof SiteCwgSearchRouteImport
    }
    '/_site/users/search/$username': {
      id: '/_site/users/search/$username'
      path: '/search/$username'
      fullPath: '/users/search/$username'
      preLoaderRoute: typeof SiteUsersSearchUsernameImport
      parentRoute: typeof SiteUsersRouteImport
    }
    '/_site/admin/groups/': {
      id: '/_site/admin/groups/'
      path: '/groups'
      fullPath: '/admin/groups'
      preLoaderRoute: typeof SiteAdminGroupsIndexImport
      parentRoute: typeof SiteAdminRouteImport
    }
    '/_site/admin/news/': {
      id: '/_site/admin/news/'
      path: '/news'
      fullPath: '/admin/news'
      preLoaderRoute: typeof SiteAdminNewsIndexImport
      parentRoute: typeof SiteAdminRouteImport
    }
    '/_site/admin/users/': {
      id: '/_site/admin/users/'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof SiteAdminUsersIndexImport
      parentRoute: typeof SiteAdminRouteImport
    }
    '/_site/cwg-collection/browse/': {
      id: '/_site/cwg-collection/browse/'
      path: '/'
      fullPath: '/cwg-collection/browse/'
      preLoaderRoute: typeof SiteCwgCollectionBrowseIndexImport
      parentRoute: typeof SiteCwgCollectionBrowseRouteImport
    }
    '/_site/cwg/browse/': {
      id: '/_site/cwg/browse/'
      path: '/'
      fullPath: '/cwg/browse/'
      preLoaderRoute: typeof SiteCwgBrowseIndexImport
      parentRoute: typeof SiteCwgBrowseRouteImport
    }
    '/_site/cwg/search/': {
      id: '/_site/cwg/search/'
      path: '/'
      fullPath: '/cwg/search/'
      preLoaderRoute: typeof SiteCwgSearchIndexImport
      parentRoute: typeof SiteCwgSearchRouteImport
    }
    '/_site/users/search/': {
      id: '/_site/users/search/'
      path: '/search'
      fullPath: '/users/search'
      preLoaderRoute: typeof SiteUsersSearchIndexImport
      parentRoute: typeof SiteUsersRouteImport
    }
    '/_site/news/index/$id': {
      id: '/_site/news/index/$id'
      path: '/news/index/$id'
      fullPath: '/news/index/$id'
      preLoaderRoute: typeof SiteNewsIndexIdImport
      parentRoute: typeof SiteRouteImport
    }
    '/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName': {
      id: '/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName'
      path: '/$primaryCategoryName'
      fullPath: '/cwg-collection/browse/$primarySorting/$primaryCategoryName'
      preLoaderRoute: typeof SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameRouteImport
      parentRoute: typeof SiteCwgCollectionBrowsePrimarySortingRouteImport
    }
    '/_site/cwg/browse/$primarySorting/$primaryCategoryName': {
      id: '/_site/cwg/browse/$primarySorting/$primaryCategoryName'
      path: '/$primaryCategoryName'
      fullPath: '/cwg/browse/$primarySorting/$primaryCategoryName'
      preLoaderRoute: typeof SiteCwgBrowsePrimarySortingPrimaryCategoryNameRouteImport
      parentRoute: typeof SiteCwgBrowsePrimarySortingRouteImport
    }
    '/_site/users/_public_profile/collection/$username': {
      id: '/_site/users/_public_profile/collection/$username'
      path: '/collection/$username'
      fullPath: '/users/collection/$username'
      preLoaderRoute: typeof SiteUsersPublicprofileCollectionUsernameRouteImport
      parentRoute: typeof SiteUsersPublicprofileRouteImport
    }
    '/_site/users/_public_profile/notwant/$username': {
      id: '/_site/users/_public_profile/notwant/$username'
      path: '/notwant/$username'
      fullPath: '/users/notwant/$username'
      preLoaderRoute: typeof SiteUsersPublicprofileNotwantUsernameRouteImport
      parentRoute: typeof SiteUsersPublicprofileRouteImport
    }
    '/_site/users/_public_profile/offers/$username': {
      id: '/_site/users/_public_profile/offers/$username'
      path: '/offers/$username'
      fullPath: '/users/offers/$username'
      preLoaderRoute: typeof SiteUsersPublicprofileOffersUsernameRouteImport
      parentRoute: typeof SiteUsersPublicprofileRouteImport
    }
    '/_site/users/_public_profile/wants/$username': {
      id: '/_site/users/_public_profile/wants/$username'
      path: '/wants/$username'
      fullPath: '/users/wants/$username'
      preLoaderRoute: typeof SiteUsersPublicprofileWantsUsernameRouteImport
      parentRoute: typeof SiteUsersPublicprofileRouteImport
    }
    '/_site/admin/approving/_queue/all': {
      id: '/_site/admin/approving/_queue/all'
      path: '/all'
      fullPath: '/admin/approving/all'
      preLoaderRoute: typeof SiteAdminApprovingQueueAllImport
      parentRoute: typeof SiteAdminApprovingQueueRouteImport
    }
    '/_site/admin/approving/_queue/holds': {
      id: '/_site/admin/approving/_queue/holds'
      path: '/holds'
      fullPath: '/admin/approving/holds'
      preLoaderRoute: typeof SiteAdminApprovingQueueHoldsImport
      parentRoute: typeof SiteAdminApprovingQueueRouteImport
    }
    '/_site/admin/groups/$groupId/modify': {
      id: '/_site/admin/groups/$groupId/modify'
      path: '/groups/$groupId/modify'
      fullPath: '/admin/groups/$groupId/modify'
      preLoaderRoute: typeof SiteAdminGroupsGroupIdModifyImport
      parentRoute: typeof SiteAdminRouteImport
    }
    '/_site/admin/news/modify/$id': {
      id: '/_site/admin/news/modify/$id'
      path: '/news/modify/$id'
      fullPath: '/admin/news/modify/$id'
      preLoaderRoute: typeof SiteAdminNewsModifyIdImport
      parentRoute: typeof SiteAdminRouteImport
    }
    '/_site/admin/users/$userId/groups': {
      id: '/_site/admin/users/$userId/groups'
      path: '/users/$userId/groups'
      fullPath: '/admin/users/$userId/groups'
      preLoaderRoute: typeof SiteAdminUsersUserIdGroupsImport
      parentRoute: typeof SiteAdminRouteImport
    }
    '/_site/admin/users/$userId/privileges': {
      id: '/_site/admin/users/$userId/privileges'
      path: '/users/$userId/privileges'
      fullPath: '/admin/users/$userId/privileges'
      preLoaderRoute: typeof SiteAdminUsersUserIdPrivilegesImport
      parentRoute: typeof SiteAdminRouteImport
    }
    '/_site/cwg/browse/advanced/$filter': {
      id: '/_site/cwg/browse/advanced/$filter'
      path: '/$filter'
      fullPath: '/cwg/browse/advanced/$filter'
      preLoaderRoute: typeof SiteCwgBrowseAdvancedFilterImport
      parentRoute: typeof SiteCwgBrowseAdvancedRouteImport
    }
    '/_site/users/_public_profile/messages/$username': {
      id: '/_site/users/_public_profile/messages/$username'
      path: '/messages/$username'
      fullPath: '/users/messages/$username'
      preLoaderRoute: typeof SiteUsersPublicprofileMessagesUsernameImport
      parentRoute: typeof SiteUsersPublicprofileRouteImport
    }
    '/_site/admin/approving/_queue/': {
      id: '/_site/admin/approving/_queue/'
      path: '/'
      fullPath: '/admin/approving/'
      preLoaderRoute: typeof SiteAdminApprovingQueueIndexImport
      parentRoute: typeof SiteAdminApprovingQueueRouteImport
    }
    '/_site/cwg-collection/browse/$primarySorting/': {
      id: '/_site/cwg-collection/browse/$primarySorting/'
      path: '/'
      fullPath: '/cwg-collection/browse/$primarySorting/'
      preLoaderRoute: typeof SiteCwgCollectionBrowsePrimarySortingIndexImport
      parentRoute: typeof SiteCwgCollectionBrowsePrimarySortingRouteImport
    }
    '/_site/cwg/browse/$primarySorting/': {
      id: '/_site/cwg/browse/$primarySorting/'
      path: '/'
      fullPath: '/cwg/browse/$primarySorting/'
      preLoaderRoute: typeof SiteCwgBrowsePrimarySortingIndexImport
      parentRoute: typeof SiteCwgBrowsePrimarySortingRouteImport
    }
    '/_site/cwg/browse/advanced/': {
      id: '/_site/cwg/browse/advanced/'
      path: '/'
      fullPath: '/cwg/browse/advanced/'
      preLoaderRoute: typeof SiteCwgBrowseAdvancedIndexImport
      parentRoute: typeof SiteCwgBrowseAdvancedRouteImport
    }
    '/_site/cwg/index/$xwgId/': {
      id: '/_site/cwg/index/$xwgId/'
      path: '/index/$xwgId'
      fullPath: '/cwg/index/$xwgId'
      preLoaderRoute: typeof SiteCwgIndexXwgIdIndexImport
      parentRoute: typeof SiteCwgRouteImport
    }
    '/_site/cwg/index/$xwgId/images': {
      id: '/_site/cwg/index/$xwgId/images'
      path: '/index/$xwgId/images'
      fullPath: '/cwg/index/$xwgId/images'
      preLoaderRoute: typeof SiteCwgIndexXwgIdImagesImport
      parentRoute: typeof SiteCwgRouteImport
    }
    '/_site/cwg/index/$xwgId/join': {
      id: '/_site/cwg/index/$xwgId/join'
      path: '/index/$xwgId/join'
      fullPath: '/cwg/index/$xwgId/join'
      preLoaderRoute: typeof SiteCwgIndexXwgIdJoinImport
      parentRoute: typeof SiteCwgRouteImport
    }
    '/_site/users/_public_profile/index/$username': {
      id: '/_site/users/_public_profile/index/$username'
      path: '/index/$username'
      fullPath: '/users/index/$username'
      preLoaderRoute: typeof SiteUsersPublicprofileIndexUsernameImport
      parentRoute: typeof SiteUsersPublicprofileRouteImport
    }
    '/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName': {
      id: '/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName'
      path: '/$secondaryCategoryName'
      fullPath: '/cwg-collection/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName'
      preLoaderRoute: typeof SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteImport
      parentRoute: typeof SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameRouteImport
    }
    '/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/all': {
      id: '/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/all'
      path: '/all'
      fullPath: '/cwg-collection/browse/$primarySorting/$primaryCategoryName/all'
      preLoaderRoute: typeof SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameAllRouteImport
      parentRoute: typeof SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameRouteImport
    }
    '/_site/cwg/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName': {
      id: '/_site/cwg/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName'
      path: '/$secondaryCategoryName'
      fullPath: '/cwg/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName'
      preLoaderRoute: typeof SiteCwgBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteImport
      parentRoute: typeof SiteCwgBrowsePrimarySortingPrimaryCategoryNameRouteImport
    }
    '/_site/users/_public_profile/collection/$username/$primarySorting': {
      id: '/_site/users/_public_profile/collection/$username/$primarySorting'
      path: '/$primarySorting'
      fullPath: '/users/collection/$username/$primarySorting'
      preLoaderRoute: typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingRouteImport
      parentRoute: typeof SiteUsersPublicprofileCollectionUsernameRouteImport
    }
    '/_site/users/_public_profile/notwant/$username/$primarySorting': {
      id: '/_site/users/_public_profile/notwant/$username/$primarySorting'
      path: '/$primarySorting'
      fullPath: '/users/notwant/$username/$primarySorting'
      preLoaderRoute: typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingRouteImport
      parentRoute: typeof SiteUsersPublicprofileNotwantUsernameRouteImport
    }
    '/_site/users/_public_profile/offers/$username/$primarySorting': {
      id: '/_site/users/_public_profile/offers/$username/$primarySorting'
      path: '/$primarySorting'
      fullPath: '/users/offers/$username/$primarySorting'
      preLoaderRoute: typeof SiteUsersPublicprofileOffersUsernamePrimarySortingRouteImport
      parentRoute: typeof SiteUsersPublicprofileOffersUsernameRouteImport
    }
    '/_site/users/_public_profile/wants/$username/$primarySorting': {
      id: '/_site/users/_public_profile/wants/$username/$primarySorting'
      path: '/$primarySorting'
      fullPath: '/users/wants/$username/$primarySorting'
      preLoaderRoute: typeof SiteUsersPublicprofileWantsUsernamePrimarySortingRouteImport
      parentRoute: typeof SiteUsersPublicprofileWantsUsernameRouteImport
    }
    '/_site/users/_public_profile/collection/$username/all': {
      id: '/_site/users/_public_profile/collection/$username/all'
      path: '/all'
      fullPath: '/users/collection/$username/all'
      preLoaderRoute: typeof SiteUsersPublicprofileCollectionUsernameAllImport
      parentRoute: typeof SiteUsersPublicprofileCollectionUsernameRouteImport
    }
    '/_site/users/_public_profile/notwant/$username/all': {
      id: '/_site/users/_public_profile/notwant/$username/all'
      path: '/all'
      fullPath: '/users/notwant/$username/all'
      preLoaderRoute: typeof SiteUsersPublicprofileNotwantUsernameAllImport
      parentRoute: typeof SiteUsersPublicprofileNotwantUsernameRouteImport
    }
    '/_site/users/_public_profile/offers/$username/all': {
      id: '/_site/users/_public_profile/offers/$username/all'
      path: '/all'
      fullPath: '/users/offers/$username/all'
      preLoaderRoute: typeof SiteUsersPublicprofileOffersUsernameAllImport
      parentRoute: typeof SiteUsersPublicprofileOffersUsernameRouteImport
    }
    '/_site/users/_public_profile/wants/$username/all': {
      id: '/_site/users/_public_profile/wants/$username/all'
      path: '/all'
      fullPath: '/users/wants/$username/all'
      preLoaderRoute: typeof SiteUsersPublicprofileWantsUsernameAllImport
      parentRoute: typeof SiteUsersPublicprofileWantsUsernameRouteImport
    }
    '/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/': {
      id: '/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/'
      path: '/'
      fullPath: '/cwg-collection/browse/$primarySorting/$primaryCategoryName/'
      preLoaderRoute: typeof SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameIndexImport
      parentRoute: typeof SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameRouteImport
    }
    '/_site/cwg/browse/$primarySorting/$primaryCategoryName/': {
      id: '/_site/cwg/browse/$primarySorting/$primaryCategoryName/'
      path: '/'
      fullPath: '/cwg/browse/$primarySorting/$primaryCategoryName/'
      preLoaderRoute: typeof SiteCwgBrowsePrimarySortingPrimaryCategoryNameIndexImport
      parentRoute: typeof SiteCwgBrowsePrimarySortingPrimaryCategoryNameRouteImport
    }
    '/_site/users/_public_profile/collection/$username/': {
      id: '/_site/users/_public_profile/collection/$username/'
      path: '/'
      fullPath: '/users/collection/$username/'
      preLoaderRoute: typeof SiteUsersPublicprofileCollectionUsernameIndexImport
      parentRoute: typeof SiteUsersPublicprofileCollectionUsernameRouteImport
    }
    '/_site/users/_public_profile/notwant/$username/': {
      id: '/_site/users/_public_profile/notwant/$username/'
      path: '/'
      fullPath: '/users/notwant/$username/'
      preLoaderRoute: typeof SiteUsersPublicprofileNotwantUsernameIndexImport
      parentRoute: typeof SiteUsersPublicprofileNotwantUsernameRouteImport
    }
    '/_site/users/_public_profile/offers/$username/': {
      id: '/_site/users/_public_profile/offers/$username/'
      path: '/'
      fullPath: '/users/offers/$username/'
      preLoaderRoute: typeof SiteUsersPublicprofileOffersUsernameIndexImport
      parentRoute: typeof SiteUsersPublicprofileOffersUsernameRouteImport
    }
    '/_site/users/_public_profile/wants/$username/': {
      id: '/_site/users/_public_profile/wants/$username/'
      path: '/'
      fullPath: '/users/wants/$username/'
      preLoaderRoute: typeof SiteUsersPublicprofileWantsUsernameIndexImport
      parentRoute: typeof SiteUsersPublicprofileWantsUsernameRouteImport
    }
    '/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName': {
      id: '/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName'
      path: '/$primaryCategoryName'
      fullPath: '/users/collection/$username/$primarySorting/$primaryCategoryName'
      preLoaderRoute: typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameRouteImport
      parentRoute: typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingRouteImport
    }
    '/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName': {
      id: '/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName'
      path: '/$primaryCategoryName'
      fullPath: '/users/notwant/$username/$primarySorting/$primaryCategoryName'
      preLoaderRoute: typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameRouteImport
      parentRoute: typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingRouteImport
    }
    '/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName': {
      id: '/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName'
      path: '/$primaryCategoryName'
      fullPath: '/users/offers/$username/$primarySorting/$primaryCategoryName'
      preLoaderRoute: typeof SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameRouteImport
      parentRoute: typeof SiteUsersPublicprofileOffersUsernamePrimarySortingRouteImport
    }
    '/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName': {
      id: '/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName'
      path: '/$primaryCategoryName'
      fullPath: '/users/wants/$username/$primarySorting/$primaryCategoryName'
      preLoaderRoute: typeof SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameRouteImport
      parentRoute: typeof SiteUsersPublicprofileWantsUsernamePrimarySortingRouteImport
    }
    '/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName/': {
      id: '/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName/'
      path: '/'
      fullPath: '/cwg-collection/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName/'
      preLoaderRoute: typeof SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexImport
      parentRoute: typeof SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteImport
    }
    '/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/all/': {
      id: '/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/all/'
      path: '/'
      fullPath: '/cwg-collection/browse/$primarySorting/$primaryCategoryName/all/'
      preLoaderRoute: typeof SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameAllIndexImport
      parentRoute: typeof SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameAllRouteImport
    }
    '/_site/cwg/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName/': {
      id: '/_site/cwg/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName/'
      path: '/'
      fullPath: '/cwg/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName/'
      preLoaderRoute: typeof SiteCwgBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexImport
      parentRoute: typeof SiteCwgBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteImport
    }
    '/_site/users/_public_profile/collection/$username/$primarySorting/': {
      id: '/_site/users/_public_profile/collection/$username/$primarySorting/'
      path: '/'
      fullPath: '/users/collection/$username/$primarySorting/'
      preLoaderRoute: typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingIndexImport
      parentRoute: typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingRouteImport
    }
    '/_site/users/_public_profile/notwant/$username/$primarySorting/': {
      id: '/_site/users/_public_profile/notwant/$username/$primarySorting/'
      path: '/'
      fullPath: '/users/notwant/$username/$primarySorting/'
      preLoaderRoute: typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingIndexImport
      parentRoute: typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingRouteImport
    }
    '/_site/users/_public_profile/offers/$username/$primarySorting/': {
      id: '/_site/users/_public_profile/offers/$username/$primarySorting/'
      path: '/'
      fullPath: '/users/offers/$username/$primarySorting/'
      preLoaderRoute: typeof SiteUsersPublicprofileOffersUsernamePrimarySortingIndexImport
      parentRoute: typeof SiteUsersPublicprofileOffersUsernamePrimarySortingRouteImport
    }
    '/_site/users/_public_profile/wants/$username/$primarySorting/': {
      id: '/_site/users/_public_profile/wants/$username/$primarySorting/'
      path: '/'
      fullPath: '/users/wants/$username/$primarySorting/'
      preLoaderRoute: typeof SiteUsersPublicprofileWantsUsernamePrimarySortingIndexImport
      parentRoute: typeof SiteUsersPublicprofileWantsUsernamePrimarySortingRouteImport
    }
    '/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName': {
      id: '/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName'
      path: '/$secondaryCategoryName'
      fullPath: '/users/collection/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName'
      preLoaderRoute: typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteImport
      parentRoute: typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameRouteImport
    }
    '/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName/all': {
      id: '/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName/all'
      path: '/all'
      fullPath: '/users/collection/$username/$primarySorting/$primaryCategoryName/all'
      preLoaderRoute: typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameAllRouteImport
      parentRoute: typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameRouteImport
    }
    '/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName': {
      id: '/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName'
      path: '/$secondaryCategoryName'
      fullPath: '/users/notwant/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName'
      preLoaderRoute: typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteImport
      parentRoute: typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameRouteImport
    }
    '/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName/all': {
      id: '/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName/all'
      path: '/all'
      fullPath: '/users/notwant/$username/$primarySorting/$primaryCategoryName/all'
      preLoaderRoute: typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameAllRouteImport
      parentRoute: typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameRouteImport
    }
    '/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName': {
      id: '/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName'
      path: '/$secondaryCategoryName'
      fullPath: '/users/offers/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName'
      preLoaderRoute: typeof SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteImport
      parentRoute: typeof SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameRouteImport
    }
    '/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName/all': {
      id: '/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName/all'
      path: '/all'
      fullPath: '/users/offers/$username/$primarySorting/$primaryCategoryName/all'
      preLoaderRoute: typeof SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameAllRouteImport
      parentRoute: typeof SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameRouteImport
    }
    '/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName': {
      id: '/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName'
      path: '/$secondaryCategoryName'
      fullPath: '/users/wants/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName'
      preLoaderRoute: typeof SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteImport
      parentRoute: typeof SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameRouteImport
    }
    '/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName/all': {
      id: '/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName/all'
      path: '/all'
      fullPath: '/users/wants/$username/$primarySorting/$primaryCategoryName/all'
      preLoaderRoute: typeof SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameAllRouteImport
      parentRoute: typeof SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameRouteImport
    }
    '/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName/': {
      id: '/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName/'
      path: '/'
      fullPath: '/users/collection/$username/$primarySorting/$primaryCategoryName/'
      preLoaderRoute: typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameIndexImport
      parentRoute: typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameRouteImport
    }
    '/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName/': {
      id: '/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName/'
      path: '/'
      fullPath: '/users/notwant/$username/$primarySorting/$primaryCategoryName/'
      preLoaderRoute: typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameIndexImport
      parentRoute: typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameRouteImport
    }
    '/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName/': {
      id: '/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName/'
      path: '/'
      fullPath: '/users/offers/$username/$primarySorting/$primaryCategoryName/'
      preLoaderRoute: typeof SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameIndexImport
      parentRoute: typeof SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameRouteImport
    }
    '/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName/': {
      id: '/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName/'
      path: '/'
      fullPath: '/users/wants/$username/$primarySorting/$primaryCategoryName/'
      preLoaderRoute: typeof SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameIndexImport
      parentRoute: typeof SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameRouteImport
    }
    '/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/': {
      id: '/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/'
      path: '/'
      fullPath: '/users/collection/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/'
      preLoaderRoute: typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexImport
      parentRoute: typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteImport
    }
    '/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName/all/': {
      id: '/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName/all/'
      path: '/'
      fullPath: '/users/collection/$username/$primarySorting/$primaryCategoryName/all/'
      preLoaderRoute: typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameAllIndexImport
      parentRoute: typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameAllRouteImport
    }
    '/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/': {
      id: '/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/'
      path: '/'
      fullPath: '/users/notwant/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/'
      preLoaderRoute: typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexImport
      parentRoute: typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteImport
    }
    '/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName/all/': {
      id: '/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName/all/'
      path: '/'
      fullPath: '/users/notwant/$username/$primarySorting/$primaryCategoryName/all/'
      preLoaderRoute: typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameAllIndexImport
      parentRoute: typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameAllRouteImport
    }
    '/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/': {
      id: '/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/'
      path: '/'
      fullPath: '/users/offers/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/'
      preLoaderRoute: typeof SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexImport
      parentRoute: typeof SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteImport
    }
    '/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName/all/': {
      id: '/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName/all/'
      path: '/'
      fullPath: '/users/offers/$username/$primarySorting/$primaryCategoryName/all/'
      preLoaderRoute: typeof SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameAllIndexImport
      parentRoute: typeof SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameAllRouteImport
    }
    '/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/': {
      id: '/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/'
      path: '/'
      fullPath: '/users/wants/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/'
      preLoaderRoute: typeof SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexImport
      parentRoute: typeof SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteImport
    }
    '/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName/all/': {
      id: '/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName/all/'
      path: '/'
      fullPath: '/users/wants/$username/$primarySorting/$primaryCategoryName/all/'
      preLoaderRoute: typeof SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameAllIndexImport
      parentRoute: typeof SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameAllRouteImport
    }
  }
}

// Create and export the route tree

interface SiteAdminApprovingQueueRouteRouteChildren {
  SiteAdminApprovingQueueAllRoute: typeof SiteAdminApprovingQueueAllRoute
  SiteAdminApprovingQueueHoldsRoute: typeof SiteAdminApprovingQueueHoldsRoute
  SiteAdminApprovingQueueIndexRoute: typeof SiteAdminApprovingQueueIndexRoute
}

const SiteAdminApprovingQueueRouteRouteChildren: SiteAdminApprovingQueueRouteRouteChildren =
  {
    SiteAdminApprovingQueueAllRoute: SiteAdminApprovingQueueAllRoute,
    SiteAdminApprovingQueueHoldsRoute: SiteAdminApprovingQueueHoldsRoute,
    SiteAdminApprovingQueueIndexRoute: SiteAdminApprovingQueueIndexRoute,
  }

const SiteAdminApprovingQueueRouteRouteWithChildren =
  SiteAdminApprovingQueueRouteRoute._addFileChildren(
    SiteAdminApprovingQueueRouteRouteChildren,
  )

interface SiteAdminApprovingRouteChildren {
  SiteAdminApprovingQueueRouteRoute: typeof SiteAdminApprovingQueueRouteRouteWithChildren
}

const SiteAdminApprovingRouteChildren: SiteAdminApprovingRouteChildren = {
  SiteAdminApprovingQueueRouteRoute:
    SiteAdminApprovingQueueRouteRouteWithChildren,
}

const SiteAdminApprovingRouteWithChildren =
  SiteAdminApprovingRoute._addFileChildren(SiteAdminApprovingRouteChildren)

interface SiteAdminRouteRouteChildren {
  SiteAdminIndexRoute: typeof SiteAdminIndexRoute
  SiteAdminApprovingRoute: typeof SiteAdminApprovingRouteWithChildren
  SiteAdminGroupsCreateRoute: typeof SiteAdminGroupsCreateRoute
  SiteAdminNewsCreateRoute: typeof SiteAdminNewsCreateRoute
  SiteAdminGroupsIndexRoute: typeof SiteAdminGroupsIndexRoute
  SiteAdminNewsIndexRoute: typeof SiteAdminNewsIndexRoute
  SiteAdminUsersIndexRoute: typeof SiteAdminUsersIndexRoute
  SiteAdminGroupsGroupIdModifyRoute: typeof SiteAdminGroupsGroupIdModifyRoute
  SiteAdminNewsModifyIdRoute: typeof SiteAdminNewsModifyIdRoute
  SiteAdminUsersUserIdGroupsRoute: typeof SiteAdminUsersUserIdGroupsRoute
  SiteAdminUsersUserIdPrivilegesRoute: typeof SiteAdminUsersUserIdPrivilegesRoute
}

const SiteAdminRouteRouteChildren: SiteAdminRouteRouteChildren = {
  SiteAdminIndexRoute: SiteAdminIndexRoute,
  SiteAdminApprovingRoute: SiteAdminApprovingRouteWithChildren,
  SiteAdminGroupsCreateRoute: SiteAdminGroupsCreateRoute,
  SiteAdminNewsCreateRoute: SiteAdminNewsCreateRoute,
  SiteAdminGroupsIndexRoute: SiteAdminGroupsIndexRoute,
  SiteAdminNewsIndexRoute: SiteAdminNewsIndexRoute,
  SiteAdminUsersIndexRoute: SiteAdminUsersIndexRoute,
  SiteAdminGroupsGroupIdModifyRoute: SiteAdminGroupsGroupIdModifyRoute,
  SiteAdminNewsModifyIdRoute: SiteAdminNewsModifyIdRoute,
  SiteAdminUsersUserIdGroupsRoute: SiteAdminUsersUserIdGroupsRoute,
  SiteAdminUsersUserIdPrivilegesRoute: SiteAdminUsersUserIdPrivilegesRoute,
}

const SiteAdminRouteRouteWithChildren = SiteAdminRouteRoute._addFileChildren(
  SiteAdminRouteRouteChildren,
)

interface SiteCwgBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteChildren {
  SiteCwgBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute: typeof SiteCwgBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute
}

const SiteCwgBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteChildren: SiteCwgBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteChildren =
  {
    SiteCwgBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute:
      SiteCwgBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute,
  }

const SiteCwgBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteWithChildren =
  SiteCwgBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRoute._addFileChildren(
    SiteCwgBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteChildren,
  )

interface SiteCwgBrowsePrimarySortingPrimaryCategoryNameRouteRouteChildren {
  SiteCwgBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRoute: typeof SiteCwgBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteWithChildren
  SiteCwgBrowsePrimarySortingPrimaryCategoryNameIndexRoute: typeof SiteCwgBrowsePrimarySortingPrimaryCategoryNameIndexRoute
}

const SiteCwgBrowsePrimarySortingPrimaryCategoryNameRouteRouteChildren: SiteCwgBrowsePrimarySortingPrimaryCategoryNameRouteRouteChildren =
  {
    SiteCwgBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRoute:
      SiteCwgBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteWithChildren,
    SiteCwgBrowsePrimarySortingPrimaryCategoryNameIndexRoute:
      SiteCwgBrowsePrimarySortingPrimaryCategoryNameIndexRoute,
  }

const SiteCwgBrowsePrimarySortingPrimaryCategoryNameRouteRouteWithChildren =
  SiteCwgBrowsePrimarySortingPrimaryCategoryNameRouteRoute._addFileChildren(
    SiteCwgBrowsePrimarySortingPrimaryCategoryNameRouteRouteChildren,
  )

interface SiteCwgBrowsePrimarySortingRouteRouteChildren {
  SiteCwgBrowsePrimarySortingPrimaryCategoryNameRouteRoute: typeof SiteCwgBrowsePrimarySortingPrimaryCategoryNameRouteRouteWithChildren
  SiteCwgBrowsePrimarySortingIndexRoute: typeof SiteCwgBrowsePrimarySortingIndexRoute
}

const SiteCwgBrowsePrimarySortingRouteRouteChildren: SiteCwgBrowsePrimarySortingRouteRouteChildren =
  {
    SiteCwgBrowsePrimarySortingPrimaryCategoryNameRouteRoute:
      SiteCwgBrowsePrimarySortingPrimaryCategoryNameRouteRouteWithChildren,
    SiteCwgBrowsePrimarySortingIndexRoute:
      SiteCwgBrowsePrimarySortingIndexRoute,
  }

const SiteCwgBrowsePrimarySortingRouteRouteWithChildren =
  SiteCwgBrowsePrimarySortingRouteRoute._addFileChildren(
    SiteCwgBrowsePrimarySortingRouteRouteChildren,
  )

interface SiteCwgBrowseAdvancedRouteRouteChildren {
  SiteCwgBrowseAdvancedFilterRoute: typeof SiteCwgBrowseAdvancedFilterRoute
  SiteCwgBrowseAdvancedIndexRoute: typeof SiteCwgBrowseAdvancedIndexRoute
}

const SiteCwgBrowseAdvancedRouteRouteChildren: SiteCwgBrowseAdvancedRouteRouteChildren =
  {
    SiteCwgBrowseAdvancedFilterRoute: SiteCwgBrowseAdvancedFilterRoute,
    SiteCwgBrowseAdvancedIndexRoute: SiteCwgBrowseAdvancedIndexRoute,
  }

const SiteCwgBrowseAdvancedRouteRouteWithChildren =
  SiteCwgBrowseAdvancedRouteRoute._addFileChildren(
    SiteCwgBrowseAdvancedRouteRouteChildren,
  )

interface SiteCwgBrowseRouteRouteChildren {
  SiteCwgBrowsePrimarySortingRouteRoute: typeof SiteCwgBrowsePrimarySortingRouteRouteWithChildren
  SiteCwgBrowseAdvancedRouteRoute: typeof SiteCwgBrowseAdvancedRouteRouteWithChildren
  SiteCwgBrowseIndexRoute: typeof SiteCwgBrowseIndexRoute
}

const SiteCwgBrowseRouteRouteChildren: SiteCwgBrowseRouteRouteChildren = {
  SiteCwgBrowsePrimarySortingRouteRoute:
    SiteCwgBrowsePrimarySortingRouteRouteWithChildren,
  SiteCwgBrowseAdvancedRouteRoute: SiteCwgBrowseAdvancedRouteRouteWithChildren,
  SiteCwgBrowseIndexRoute: SiteCwgBrowseIndexRoute,
}

const SiteCwgBrowseRouteRouteWithChildren =
  SiteCwgBrowseRouteRoute._addFileChildren(SiteCwgBrowseRouteRouteChildren)

interface SiteCwgSearchRouteRouteChildren {
  SiteCwgSearchQueryRoute: typeof SiteCwgSearchQueryRoute
  SiteCwgSearchIndexRoute: typeof SiteCwgSearchIndexRoute
}

const SiteCwgSearchRouteRouteChildren: SiteCwgSearchRouteRouteChildren = {
  SiteCwgSearchQueryRoute: SiteCwgSearchQueryRoute,
  SiteCwgSearchIndexRoute: SiteCwgSearchIndexRoute,
}

const SiteCwgSearchRouteRouteWithChildren =
  SiteCwgSearchRouteRoute._addFileChildren(SiteCwgSearchRouteRouteChildren)

interface SiteCwgRouteRouteChildren {
  SiteCwgBrowseRouteRoute: typeof SiteCwgBrowseRouteRouteWithChildren
  SiteCwgSearchRouteRoute: typeof SiteCwgSearchRouteRouteWithChildren
  SiteCwgEntryRoute: typeof SiteCwgEntryRoute
  SiteCwgOwnRoute: typeof SiteCwgOwnRoute
  SiteCwgModifyXwgIdRoute: typeof SiteCwgModifyXwgIdRoute
  SiteCwgIndexXwgIdIndexRoute: typeof SiteCwgIndexXwgIdIndexRoute
  SiteCwgIndexXwgIdImagesRoute: typeof SiteCwgIndexXwgIdImagesRoute
  SiteCwgIndexXwgIdJoinRoute: typeof SiteCwgIndexXwgIdJoinRoute
}

const SiteCwgRouteRouteChildren: SiteCwgRouteRouteChildren = {
  SiteCwgBrowseRouteRoute: SiteCwgBrowseRouteRouteWithChildren,
  SiteCwgSearchRouteRoute: SiteCwgSearchRouteRouteWithChildren,
  SiteCwgEntryRoute: SiteCwgEntryRoute,
  SiteCwgOwnRoute: SiteCwgOwnRoute,
  SiteCwgModifyXwgIdRoute: SiteCwgModifyXwgIdRoute,
  SiteCwgIndexXwgIdIndexRoute: SiteCwgIndexXwgIdIndexRoute,
  SiteCwgIndexXwgIdImagesRoute: SiteCwgIndexXwgIdImagesRoute,
  SiteCwgIndexXwgIdJoinRoute: SiteCwgIndexXwgIdJoinRoute,
}

const SiteCwgRouteRouteWithChildren = SiteCwgRouteRoute._addFileChildren(
  SiteCwgRouteRouteChildren,
)

interface SiteMessagesRouteRouteChildren {
  SiteMessagesThreadIdRoute: typeof SiteMessagesThreadIdRoute
  SiteMessagesNewRoute: typeof SiteMessagesNewRoute
  SiteMessagesIndexRoute: typeof SiteMessagesIndexRoute
}

const SiteMessagesRouteRouteChildren: SiteMessagesRouteRouteChildren = {
  SiteMessagesThreadIdRoute: SiteMessagesThreadIdRoute,
  SiteMessagesNewRoute: SiteMessagesNewRoute,
  SiteMessagesIndexRoute: SiteMessagesIndexRoute,
}

const SiteMessagesRouteRouteWithChildren =
  SiteMessagesRouteRoute._addFileChildren(SiteMessagesRouteRouteChildren)

interface SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteChildren {
  SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute: typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute
}

const SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteChildren: SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteChildren =
  {
    SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute:
      SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute,
  }

const SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteWithChildren =
  SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRoute._addFileChildren(
    SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteChildren,
  )

interface SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameAllRouteRouteChildren {
  SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameAllIndexRoute: typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameAllIndexRoute
}

const SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameAllRouteRouteChildren: SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameAllRouteRouteChildren =
  {
    SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameAllIndexRoute:
      SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameAllIndexRoute,
  }

const SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameAllRouteRouteWithChildren =
  SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameAllRouteRoute._addFileChildren(
    SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameAllRouteRouteChildren,
  )

interface SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameRouteRouteChildren {
  SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRoute: typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteWithChildren
  SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameAllRouteRoute: typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameAllRouteRouteWithChildren
  SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameIndexRoute: typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameIndexRoute
}

const SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameRouteRouteChildren: SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameRouteRouteChildren =
  {
    SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRoute:
      SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteWithChildren,
    SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameAllRouteRoute:
      SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameAllRouteRouteWithChildren,
    SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameIndexRoute:
      SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameIndexRoute,
  }

const SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameRouteRouteWithChildren =
  SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameRouteRoute._addFileChildren(
    SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameRouteRouteChildren,
  )

interface SiteUsersPublicprofileCollectionUsernamePrimarySortingRouteRouteChildren {
  SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameRouteRoute: typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameRouteRouteWithChildren
  SiteUsersPublicprofileCollectionUsernamePrimarySortingIndexRoute: typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingIndexRoute
}

const SiteUsersPublicprofileCollectionUsernamePrimarySortingRouteRouteChildren: SiteUsersPublicprofileCollectionUsernamePrimarySortingRouteRouteChildren =
  {
    SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameRouteRoute:
      SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameRouteRouteWithChildren,
    SiteUsersPublicprofileCollectionUsernamePrimarySortingIndexRoute:
      SiteUsersPublicprofileCollectionUsernamePrimarySortingIndexRoute,
  }

const SiteUsersPublicprofileCollectionUsernamePrimarySortingRouteRouteWithChildren =
  SiteUsersPublicprofileCollectionUsernamePrimarySortingRouteRoute._addFileChildren(
    SiteUsersPublicprofileCollectionUsernamePrimarySortingRouteRouteChildren,
  )

interface SiteUsersPublicprofileCollectionUsernameRouteRouteChildren {
  SiteUsersPublicprofileCollectionUsernamePrimarySortingRouteRoute: typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingRouteRouteWithChildren
  SiteUsersPublicprofileCollectionUsernameAllRoute: typeof SiteUsersPublicprofileCollectionUsernameAllRoute
  SiteUsersPublicprofileCollectionUsernameIndexRoute: typeof SiteUsersPublicprofileCollectionUsernameIndexRoute
}

const SiteUsersPublicprofileCollectionUsernameRouteRouteChildren: SiteUsersPublicprofileCollectionUsernameRouteRouteChildren =
  {
    SiteUsersPublicprofileCollectionUsernamePrimarySortingRouteRoute:
      SiteUsersPublicprofileCollectionUsernamePrimarySortingRouteRouteWithChildren,
    SiteUsersPublicprofileCollectionUsernameAllRoute:
      SiteUsersPublicprofileCollectionUsernameAllRoute,
    SiteUsersPublicprofileCollectionUsernameIndexRoute:
      SiteUsersPublicprofileCollectionUsernameIndexRoute,
  }

const SiteUsersPublicprofileCollectionUsernameRouteRouteWithChildren =
  SiteUsersPublicprofileCollectionUsernameRouteRoute._addFileChildren(
    SiteUsersPublicprofileCollectionUsernameRouteRouteChildren,
  )

interface SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteChildren {
  SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute: typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute
}

const SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteChildren: SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteChildren =
  {
    SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute:
      SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute,
  }

const SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteWithChildren =
  SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRoute._addFileChildren(
    SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteChildren,
  )

interface SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameAllRouteRouteChildren {
  SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameAllIndexRoute: typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameAllIndexRoute
}

const SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameAllRouteRouteChildren: SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameAllRouteRouteChildren =
  {
    SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameAllIndexRoute:
      SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameAllIndexRoute,
  }

const SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameAllRouteRouteWithChildren =
  SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameAllRouteRoute._addFileChildren(
    SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameAllRouteRouteChildren,
  )

interface SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameRouteRouteChildren {
  SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRoute: typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteWithChildren
  SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameAllRouteRoute: typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameAllRouteRouteWithChildren
  SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameIndexRoute: typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameIndexRoute
}

const SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameRouteRouteChildren: SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameRouteRouteChildren =
  {
    SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRoute:
      SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteWithChildren,
    SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameAllRouteRoute:
      SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameAllRouteRouteWithChildren,
    SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameIndexRoute:
      SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameIndexRoute,
  }

const SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameRouteRouteWithChildren =
  SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameRouteRoute._addFileChildren(
    SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameRouteRouteChildren,
  )

interface SiteUsersPublicprofileNotwantUsernamePrimarySortingRouteRouteChildren {
  SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameRouteRoute: typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameRouteRouteWithChildren
  SiteUsersPublicprofileNotwantUsernamePrimarySortingIndexRoute: typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingIndexRoute
}

const SiteUsersPublicprofileNotwantUsernamePrimarySortingRouteRouteChildren: SiteUsersPublicprofileNotwantUsernamePrimarySortingRouteRouteChildren =
  {
    SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameRouteRoute:
      SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameRouteRouteWithChildren,
    SiteUsersPublicprofileNotwantUsernamePrimarySortingIndexRoute:
      SiteUsersPublicprofileNotwantUsernamePrimarySortingIndexRoute,
  }

const SiteUsersPublicprofileNotwantUsernamePrimarySortingRouteRouteWithChildren =
  SiteUsersPublicprofileNotwantUsernamePrimarySortingRouteRoute._addFileChildren(
    SiteUsersPublicprofileNotwantUsernamePrimarySortingRouteRouteChildren,
  )

interface SiteUsersPublicprofileNotwantUsernameRouteRouteChildren {
  SiteUsersPublicprofileNotwantUsernamePrimarySortingRouteRoute: typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingRouteRouteWithChildren
  SiteUsersPublicprofileNotwantUsernameAllRoute: typeof SiteUsersPublicprofileNotwantUsernameAllRoute
  SiteUsersPublicprofileNotwantUsernameIndexRoute: typeof SiteUsersPublicprofileNotwantUsernameIndexRoute
}

const SiteUsersPublicprofileNotwantUsernameRouteRouteChildren: SiteUsersPublicprofileNotwantUsernameRouteRouteChildren =
  {
    SiteUsersPublicprofileNotwantUsernamePrimarySortingRouteRoute:
      SiteUsersPublicprofileNotwantUsernamePrimarySortingRouteRouteWithChildren,
    SiteUsersPublicprofileNotwantUsernameAllRoute:
      SiteUsersPublicprofileNotwantUsernameAllRoute,
    SiteUsersPublicprofileNotwantUsernameIndexRoute:
      SiteUsersPublicprofileNotwantUsernameIndexRoute,
  }

const SiteUsersPublicprofileNotwantUsernameRouteRouteWithChildren =
  SiteUsersPublicprofileNotwantUsernameRouteRoute._addFileChildren(
    SiteUsersPublicprofileNotwantUsernameRouteRouteChildren,
  )

interface SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteChildren {
  SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute: typeof SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute
}

const SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteChildren: SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteChildren =
  {
    SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute:
      SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute,
  }

const SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteWithChildren =
  SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRoute._addFileChildren(
    SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteChildren,
  )

interface SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameAllRouteRouteChildren {
  SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameAllIndexRoute: typeof SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameAllIndexRoute
}

const SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameAllRouteRouteChildren: SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameAllRouteRouteChildren =
  {
    SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameAllIndexRoute:
      SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameAllIndexRoute,
  }

const SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameAllRouteRouteWithChildren =
  SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameAllRouteRoute._addFileChildren(
    SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameAllRouteRouteChildren,
  )

interface SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameRouteRouteChildren {
  SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRoute: typeof SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteWithChildren
  SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameAllRouteRoute: typeof SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameAllRouteRouteWithChildren
  SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameIndexRoute: typeof SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameIndexRoute
}

const SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameRouteRouteChildren: SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameRouteRouteChildren =
  {
    SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRoute:
      SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteWithChildren,
    SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameAllRouteRoute:
      SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameAllRouteRouteWithChildren,
    SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameIndexRoute:
      SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameIndexRoute,
  }

const SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameRouteRouteWithChildren =
  SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameRouteRoute._addFileChildren(
    SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameRouteRouteChildren,
  )

interface SiteUsersPublicprofileOffersUsernamePrimarySortingRouteRouteChildren {
  SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameRouteRoute: typeof SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameRouteRouteWithChildren
  SiteUsersPublicprofileOffersUsernamePrimarySortingIndexRoute: typeof SiteUsersPublicprofileOffersUsernamePrimarySortingIndexRoute
}

const SiteUsersPublicprofileOffersUsernamePrimarySortingRouteRouteChildren: SiteUsersPublicprofileOffersUsernamePrimarySortingRouteRouteChildren =
  {
    SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameRouteRoute:
      SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameRouteRouteWithChildren,
    SiteUsersPublicprofileOffersUsernamePrimarySortingIndexRoute:
      SiteUsersPublicprofileOffersUsernamePrimarySortingIndexRoute,
  }

const SiteUsersPublicprofileOffersUsernamePrimarySortingRouteRouteWithChildren =
  SiteUsersPublicprofileOffersUsernamePrimarySortingRouteRoute._addFileChildren(
    SiteUsersPublicprofileOffersUsernamePrimarySortingRouteRouteChildren,
  )

interface SiteUsersPublicprofileOffersUsernameRouteRouteChildren {
  SiteUsersPublicprofileOffersUsernamePrimarySortingRouteRoute: typeof SiteUsersPublicprofileOffersUsernamePrimarySortingRouteRouteWithChildren
  SiteUsersPublicprofileOffersUsernameAllRoute: typeof SiteUsersPublicprofileOffersUsernameAllRoute
  SiteUsersPublicprofileOffersUsernameIndexRoute: typeof SiteUsersPublicprofileOffersUsernameIndexRoute
}

const SiteUsersPublicprofileOffersUsernameRouteRouteChildren: SiteUsersPublicprofileOffersUsernameRouteRouteChildren =
  {
    SiteUsersPublicprofileOffersUsernamePrimarySortingRouteRoute:
      SiteUsersPublicprofileOffersUsernamePrimarySortingRouteRouteWithChildren,
    SiteUsersPublicprofileOffersUsernameAllRoute:
      SiteUsersPublicprofileOffersUsernameAllRoute,
    SiteUsersPublicprofileOffersUsernameIndexRoute:
      SiteUsersPublicprofileOffersUsernameIndexRoute,
  }

const SiteUsersPublicprofileOffersUsernameRouteRouteWithChildren =
  SiteUsersPublicprofileOffersUsernameRouteRoute._addFileChildren(
    SiteUsersPublicprofileOffersUsernameRouteRouteChildren,
  )

interface SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteChildren {
  SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute: typeof SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute
}

const SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteChildren: SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteChildren =
  {
    SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute:
      SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute,
  }

const SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteWithChildren =
  SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRoute._addFileChildren(
    SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteChildren,
  )

interface SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameAllRouteRouteChildren {
  SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameAllIndexRoute: typeof SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameAllIndexRoute
}

const SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameAllRouteRouteChildren: SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameAllRouteRouteChildren =
  {
    SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameAllIndexRoute:
      SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameAllIndexRoute,
  }

const SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameAllRouteRouteWithChildren =
  SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameAllRouteRoute._addFileChildren(
    SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameAllRouteRouteChildren,
  )

interface SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameRouteRouteChildren {
  SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRoute: typeof SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteWithChildren
  SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameAllRouteRoute: typeof SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameAllRouteRouteWithChildren
  SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameIndexRoute: typeof SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameIndexRoute
}

const SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameRouteRouteChildren: SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameRouteRouteChildren =
  {
    SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRoute:
      SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteWithChildren,
    SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameAllRouteRoute:
      SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameAllRouteRouteWithChildren,
    SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameIndexRoute:
      SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameIndexRoute,
  }

const SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameRouteRouteWithChildren =
  SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameRouteRoute._addFileChildren(
    SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameRouteRouteChildren,
  )

interface SiteUsersPublicprofileWantsUsernamePrimarySortingRouteRouteChildren {
  SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameRouteRoute: typeof SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameRouteRouteWithChildren
  SiteUsersPublicprofileWantsUsernamePrimarySortingIndexRoute: typeof SiteUsersPublicprofileWantsUsernamePrimarySortingIndexRoute
}

const SiteUsersPublicprofileWantsUsernamePrimarySortingRouteRouteChildren: SiteUsersPublicprofileWantsUsernamePrimarySortingRouteRouteChildren =
  {
    SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameRouteRoute:
      SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameRouteRouteWithChildren,
    SiteUsersPublicprofileWantsUsernamePrimarySortingIndexRoute:
      SiteUsersPublicprofileWantsUsernamePrimarySortingIndexRoute,
  }

const SiteUsersPublicprofileWantsUsernamePrimarySortingRouteRouteWithChildren =
  SiteUsersPublicprofileWantsUsernamePrimarySortingRouteRoute._addFileChildren(
    SiteUsersPublicprofileWantsUsernamePrimarySortingRouteRouteChildren,
  )

interface SiteUsersPublicprofileWantsUsernameRouteRouteChildren {
  SiteUsersPublicprofileWantsUsernamePrimarySortingRouteRoute: typeof SiteUsersPublicprofileWantsUsernamePrimarySortingRouteRouteWithChildren
  SiteUsersPublicprofileWantsUsernameAllRoute: typeof SiteUsersPublicprofileWantsUsernameAllRoute
  SiteUsersPublicprofileWantsUsernameIndexRoute: typeof SiteUsersPublicprofileWantsUsernameIndexRoute
}

const SiteUsersPublicprofileWantsUsernameRouteRouteChildren: SiteUsersPublicprofileWantsUsernameRouteRouteChildren =
  {
    SiteUsersPublicprofileWantsUsernamePrimarySortingRouteRoute:
      SiteUsersPublicprofileWantsUsernamePrimarySortingRouteRouteWithChildren,
    SiteUsersPublicprofileWantsUsernameAllRoute:
      SiteUsersPublicprofileWantsUsernameAllRoute,
    SiteUsersPublicprofileWantsUsernameIndexRoute:
      SiteUsersPublicprofileWantsUsernameIndexRoute,
  }

const SiteUsersPublicprofileWantsUsernameRouteRouteWithChildren =
  SiteUsersPublicprofileWantsUsernameRouteRoute._addFileChildren(
    SiteUsersPublicprofileWantsUsernameRouteRouteChildren,
  )

interface SiteUsersPublicprofileRouteRouteChildren {
  SiteUsersPublicprofileCollectionUsernameRouteRoute: typeof SiteUsersPublicprofileCollectionUsernameRouteRouteWithChildren
  SiteUsersPublicprofileNotwantUsernameRouteRoute: typeof SiteUsersPublicprofileNotwantUsernameRouteRouteWithChildren
  SiteUsersPublicprofileOffersUsernameRouteRoute: typeof SiteUsersPublicprofileOffersUsernameRouteRouteWithChildren
  SiteUsersPublicprofileWantsUsernameRouteRoute: typeof SiteUsersPublicprofileWantsUsernameRouteRouteWithChildren
  SiteUsersPublicprofileMessagesUsernameRoute: typeof SiteUsersPublicprofileMessagesUsernameRoute
  SiteUsersPublicprofileIndexUsernameRoute: typeof SiteUsersPublicprofileIndexUsernameRoute
}

const SiteUsersPublicprofileRouteRouteChildren: SiteUsersPublicprofileRouteRouteChildren =
  {
    SiteUsersPublicprofileCollectionUsernameRouteRoute:
      SiteUsersPublicprofileCollectionUsernameRouteRouteWithChildren,
    SiteUsersPublicprofileNotwantUsernameRouteRoute:
      SiteUsersPublicprofileNotwantUsernameRouteRouteWithChildren,
    SiteUsersPublicprofileOffersUsernameRouteRoute:
      SiteUsersPublicprofileOffersUsernameRouteRouteWithChildren,
    SiteUsersPublicprofileWantsUsernameRouteRoute:
      SiteUsersPublicprofileWantsUsernameRouteRouteWithChildren,
    SiteUsersPublicprofileMessagesUsernameRoute:
      SiteUsersPublicprofileMessagesUsernameRoute,
    SiteUsersPublicprofileIndexUsernameRoute:
      SiteUsersPublicprofileIndexUsernameRoute,
  }

const SiteUsersPublicprofileRouteRouteWithChildren =
  SiteUsersPublicprofileRouteRoute._addFileChildren(
    SiteUsersPublicprofileRouteRouteChildren,
  )

interface SiteUsersRouteRouteChildren {
  SiteUsersPublicprofileRouteRoute: typeof SiteUsersPublicprofileRouteRouteWithChildren
  SiteUsersProfileRoute: typeof SiteUsersProfileRoute
  SiteUsersStatsRoute: typeof SiteUsersStatsRoute
  SiteUsersStatsoffersRoute: typeof SiteUsersStatsoffersRoute
  SiteUsersSearchUsernameRoute: typeof SiteUsersSearchUsernameRoute
  SiteUsersSearchIndexRoute: typeof SiteUsersSearchIndexRoute
}

const SiteUsersRouteRouteChildren: SiteUsersRouteRouteChildren = {
  SiteUsersPublicprofileRouteRoute:
    SiteUsersPublicprofileRouteRouteWithChildren,
  SiteUsersProfileRoute: SiteUsersProfileRoute,
  SiteUsersStatsRoute: SiteUsersStatsRoute,
  SiteUsersStatsoffersRoute: SiteUsersStatsoffersRoute,
  SiteUsersSearchUsernameRoute: SiteUsersSearchUsernameRoute,
  SiteUsersSearchIndexRoute: SiteUsersSearchIndexRoute,
}

const SiteUsersRouteRouteWithChildren = SiteUsersRouteRoute._addFileChildren(
  SiteUsersRouteRouteChildren,
)

interface SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteChildren {
  SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute: typeof SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute
}

const SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteChildren: SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteChildren =
  {
    SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute:
      SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute,
  }

const SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteWithChildren =
  SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRoute._addFileChildren(
    SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteChildren,
  )

interface SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameAllRouteRouteChildren {
  SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameAllIndexRoute: typeof SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameAllIndexRoute
}

const SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameAllRouteRouteChildren: SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameAllRouteRouteChildren =
  {
    SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameAllIndexRoute:
      SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameAllIndexRoute,
  }

const SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameAllRouteRouteWithChildren =
  SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameAllRouteRoute._addFileChildren(
    SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameAllRouteRouteChildren,
  )

interface SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameRouteRouteChildren {
  SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRoute: typeof SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteWithChildren
  SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameAllRouteRoute: typeof SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameAllRouteRouteWithChildren
  SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameIndexRoute: typeof SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameIndexRoute
}

const SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameRouteRouteChildren: SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameRouteRouteChildren =
  {
    SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRoute:
      SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteWithChildren,
    SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameAllRouteRoute:
      SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameAllRouteRouteWithChildren,
    SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameIndexRoute:
      SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameIndexRoute,
  }

const SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameRouteRouteWithChildren =
  SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameRouteRoute._addFileChildren(
    SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameRouteRouteChildren,
  )

interface SiteCwgCollectionBrowsePrimarySortingRouteRouteChildren {
  SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameRouteRoute: typeof SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameRouteRouteWithChildren
  SiteCwgCollectionBrowsePrimarySortingIndexRoute: typeof SiteCwgCollectionBrowsePrimarySortingIndexRoute
}

const SiteCwgCollectionBrowsePrimarySortingRouteRouteChildren: SiteCwgCollectionBrowsePrimarySortingRouteRouteChildren =
  {
    SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameRouteRoute:
      SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameRouteRouteWithChildren,
    SiteCwgCollectionBrowsePrimarySortingIndexRoute:
      SiteCwgCollectionBrowsePrimarySortingIndexRoute,
  }

const SiteCwgCollectionBrowsePrimarySortingRouteRouteWithChildren =
  SiteCwgCollectionBrowsePrimarySortingRouteRoute._addFileChildren(
    SiteCwgCollectionBrowsePrimarySortingRouteRouteChildren,
  )

interface SiteCwgCollectionBrowseRouteRouteChildren {
  SiteCwgCollectionBrowsePrimarySortingRouteRoute: typeof SiteCwgCollectionBrowsePrimarySortingRouteRouteWithChildren
  SiteCwgCollectionBrowseAllRoute: typeof SiteCwgCollectionBrowseAllRoute
  SiteCwgCollectionBrowseIndexRoute: typeof SiteCwgCollectionBrowseIndexRoute
}

const SiteCwgCollectionBrowseRouteRouteChildren: SiteCwgCollectionBrowseRouteRouteChildren =
  {
    SiteCwgCollectionBrowsePrimarySortingRouteRoute:
      SiteCwgCollectionBrowsePrimarySortingRouteRouteWithChildren,
    SiteCwgCollectionBrowseAllRoute: SiteCwgCollectionBrowseAllRoute,
    SiteCwgCollectionBrowseIndexRoute: SiteCwgCollectionBrowseIndexRoute,
  }

const SiteCwgCollectionBrowseRouteRouteWithChildren =
  SiteCwgCollectionBrowseRouteRoute._addFileChildren(
    SiteCwgCollectionBrowseRouteRouteChildren,
  )

interface SiteRouteRouteChildren {
  SiteAdminRouteRoute: typeof SiteAdminRouteRouteWithChildren
  SiteCwgRouteRoute: typeof SiteCwgRouteRouteWithChildren
  SiteMessagesRouteRoute: typeof SiteMessagesRouteRouteWithChildren
  SiteUsersRouteRoute: typeof SiteUsersRouteRouteWithChildren
  SiteChangePasswordRoute: typeof SiteChangePasswordRoute
  SiteRecoverPasswordRoute: typeof SiteRecoverPasswordRoute
  SiteReportRoute: typeof SiteReportRoute
  SiteVerifyEmailRoute: typeof SiteVerifyEmailRoute
  SiteIndexRoute: typeof SiteIndexRoute
  SiteCwgCollectionBrowseRouteRoute: typeof SiteCwgCollectionBrowseRouteRouteWithChildren
  SiteApplicationsClientIdRoute: typeof SiteApplicationsClientIdRoute
  SiteApplicationsRegisterRoute: typeof SiteApplicationsRegisterRoute
  SiteCwgCollectionDuplicatesRoute: typeof SiteCwgCollectionDuplicatesRoute
  SiteCwgCollectionTagsRoute: typeof SiteCwgCollectionTagsRoute
  SiteCwgMainApiRoute: typeof SiteCwgMainApiRoute
  SiteNewsArchiveRoute: typeof SiteNewsArchiveRoute
  SiteApplicationsIndexRoute: typeof SiteApplicationsIndexRoute
  SiteNewsIndexIdRoute: typeof SiteNewsIndexIdRoute
}

const SiteRouteRouteChildren: SiteRouteRouteChildren = {
  SiteAdminRouteRoute: SiteAdminRouteRouteWithChildren,
  SiteCwgRouteRoute: SiteCwgRouteRouteWithChildren,
  SiteMessagesRouteRoute: SiteMessagesRouteRouteWithChildren,
  SiteUsersRouteRoute: SiteUsersRouteRouteWithChildren,
  SiteChangePasswordRoute: SiteChangePasswordRoute,
  SiteRecoverPasswordRoute: SiteRecoverPasswordRoute,
  SiteReportRoute: SiteReportRoute,
  SiteVerifyEmailRoute: SiteVerifyEmailRoute,
  SiteIndexRoute: SiteIndexRoute,
  SiteCwgCollectionBrowseRouteRoute:
    SiteCwgCollectionBrowseRouteRouteWithChildren,
  SiteApplicationsClientIdRoute: SiteApplicationsClientIdRoute,
  SiteApplicationsRegisterRoute: SiteApplicationsRegisterRoute,
  SiteCwgCollectionDuplicatesRoute: SiteCwgCollectionDuplicatesRoute,
  SiteCwgCollectionTagsRoute: SiteCwgCollectionTagsRoute,
  SiteCwgMainApiRoute: SiteCwgMainApiRoute,
  SiteNewsArchiveRoute: SiteNewsArchiveRoute,
  SiteApplicationsIndexRoute: SiteApplicationsIndexRoute,
  SiteNewsIndexIdRoute: SiteNewsIndexIdRoute,
}

const SiteRouteRouteWithChildren = SiteRouteRoute._addFileChildren(
  SiteRouteRouteChildren,
)

interface LoginRouteRouteChildren {
  LoginAuthorizeRoute: typeof LoginAuthorizeRoute
  LoginIndexRoute: typeof LoginIndexRoute
}

const LoginRouteRouteChildren: LoginRouteRouteChildren = {
  LoginAuthorizeRoute: LoginAuthorizeRoute,
  LoginIndexRoute: LoginIndexRoute,
}

const LoginRouteRouteWithChildren = LoginRouteRoute._addFileChildren(
  LoginRouteRouteChildren,
)

export interface FileRoutesByFullPath {
  '': typeof SiteRouteRouteWithChildren
  '/login': typeof LoginRouteRouteWithChildren
  '/admin': typeof SiteAdminRouteRouteWithChildren
  '/cwg': typeof SiteCwgRouteRouteWithChildren
  '/messages': typeof SiteMessagesRouteRouteWithChildren
  '/users': typeof SiteUsersPublicprofileRouteRouteWithChildren
  '/change-password': typeof SiteChangePasswordRoute
  '/recover-password': typeof SiteRecoverPasswordRoute
  '/report': typeof SiteReportRoute
  '/verify-email': typeof SiteVerifyEmailRoute
  '/login/authorize': typeof LoginAuthorizeRoute
  '/': typeof SiteIndexRoute
  '/login/': typeof LoginIndexRoute
  '/cwg-collection/browse': typeof SiteCwgCollectionBrowseRouteRouteWithChildren
  '/cwg/browse': typeof SiteCwgBrowseRouteRouteWithChildren
  '/cwg/search': typeof SiteCwgSearchRouteRouteWithChildren
  '/applications/$clientId': typeof SiteApplicationsClientIdRoute
  '/applications/register': typeof SiteApplicationsRegisterRoute
  '/cwg-collection/duplicates': typeof SiteCwgCollectionDuplicatesRoute
  '/cwg-collection/tags': typeof SiteCwgCollectionTagsRoute
  '/cwg-main/api': typeof SiteCwgMainApiRoute
  '/cwg/entry': typeof SiteCwgEntryRoute
  '/cwg/own': typeof SiteCwgOwnRoute
  '/messages/$threadId': typeof SiteMessagesThreadIdRoute
  '/messages/new': typeof SiteMessagesNewRoute
  '/news/archive': typeof SiteNewsArchiveRoute
  '/users/profile': typeof SiteUsersProfileRoute
  '/users/stats': typeof SiteUsersStatsRoute
  '/users/stats_offers': typeof SiteUsersStatsoffersRoute
  '/admin/': typeof SiteAdminIndexRoute
  '/applications': typeof SiteApplicationsIndexRoute
  '/messages/': typeof SiteMessagesIndexRoute
  '/admin/approving': typeof SiteAdminApprovingQueueRouteRouteWithChildren
  '/cwg-collection/browse/$primarySorting': typeof SiteCwgCollectionBrowsePrimarySortingRouteRouteWithChildren
  '/cwg/browse/$primarySorting': typeof SiteCwgBrowsePrimarySortingRouteRouteWithChildren
  '/cwg/browse/advanced': typeof SiteCwgBrowseAdvancedRouteRouteWithChildren
  '/admin/groups/create': typeof SiteAdminGroupsCreateRoute
  '/admin/news/create': typeof SiteAdminNewsCreateRoute
  '/cwg-collection/browse/all': typeof SiteCwgCollectionBrowseAllRoute
  '/cwg/modify/$xwgId': typeof SiteCwgModifyXwgIdRoute
  '/cwg/search/$query': typeof SiteCwgSearchQueryRoute
  '/users/search/$username': typeof SiteUsersSearchUsernameRoute
  '/admin/groups': typeof SiteAdminGroupsIndexRoute
  '/admin/news': typeof SiteAdminNewsIndexRoute
  '/admin/users': typeof SiteAdminUsersIndexRoute
  '/cwg-collection/browse/': typeof SiteCwgCollectionBrowseIndexRoute
  '/cwg/browse/': typeof SiteCwgBrowseIndexRoute
  '/cwg/search/': typeof SiteCwgSearchIndexRoute
  '/users/search': typeof SiteUsersSearchIndexRoute
  '/news/index/$id': typeof SiteNewsIndexIdRoute
  '/cwg-collection/browse/$primarySorting/$primaryCategoryName': typeof SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameRouteRouteWithChildren
  '/cwg/browse/$primarySorting/$primaryCategoryName': typeof SiteCwgBrowsePrimarySortingPrimaryCategoryNameRouteRouteWithChildren
  '/users/collection/$username': typeof SiteUsersPublicprofileCollectionUsernameRouteRouteWithChildren
  '/users/notwant/$username': typeof SiteUsersPublicprofileNotwantUsernameRouteRouteWithChildren
  '/users/offers/$username': typeof SiteUsersPublicprofileOffersUsernameRouteRouteWithChildren
  '/users/wants/$username': typeof SiteUsersPublicprofileWantsUsernameRouteRouteWithChildren
  '/admin/approving/all': typeof SiteAdminApprovingQueueAllRoute
  '/admin/approving/holds': typeof SiteAdminApprovingQueueHoldsRoute
  '/admin/groups/$groupId/modify': typeof SiteAdminGroupsGroupIdModifyRoute
  '/admin/news/modify/$id': typeof SiteAdminNewsModifyIdRoute
  '/admin/users/$userId/groups': typeof SiteAdminUsersUserIdGroupsRoute
  '/admin/users/$userId/privileges': typeof SiteAdminUsersUserIdPrivilegesRoute
  '/cwg/browse/advanced/$filter': typeof SiteCwgBrowseAdvancedFilterRoute
  '/users/messages/$username': typeof SiteUsersPublicprofileMessagesUsernameRoute
  '/admin/approving/': typeof SiteAdminApprovingQueueIndexRoute
  '/cwg-collection/browse/$primarySorting/': typeof SiteCwgCollectionBrowsePrimarySortingIndexRoute
  '/cwg/browse/$primarySorting/': typeof SiteCwgBrowsePrimarySortingIndexRoute
  '/cwg/browse/advanced/': typeof SiteCwgBrowseAdvancedIndexRoute
  '/cwg/index/$xwgId': typeof SiteCwgIndexXwgIdIndexRoute
  '/cwg/index/$xwgId/images': typeof SiteCwgIndexXwgIdImagesRoute
  '/cwg/index/$xwgId/join': typeof SiteCwgIndexXwgIdJoinRoute
  '/users/index/$username': typeof SiteUsersPublicprofileIndexUsernameRoute
  '/cwg-collection/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName': typeof SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteWithChildren
  '/cwg-collection/browse/$primarySorting/$primaryCategoryName/all': typeof SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameAllRouteRouteWithChildren
  '/cwg/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName': typeof SiteCwgBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteWithChildren
  '/users/collection/$username/$primarySorting': typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingRouteRouteWithChildren
  '/users/notwant/$username/$primarySorting': typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingRouteRouteWithChildren
  '/users/offers/$username/$primarySorting': typeof SiteUsersPublicprofileOffersUsernamePrimarySortingRouteRouteWithChildren
  '/users/wants/$username/$primarySorting': typeof SiteUsersPublicprofileWantsUsernamePrimarySortingRouteRouteWithChildren
  '/users/collection/$username/all': typeof SiteUsersPublicprofileCollectionUsernameAllRoute
  '/users/notwant/$username/all': typeof SiteUsersPublicprofileNotwantUsernameAllRoute
  '/users/offers/$username/all': typeof SiteUsersPublicprofileOffersUsernameAllRoute
  '/users/wants/$username/all': typeof SiteUsersPublicprofileWantsUsernameAllRoute
  '/cwg-collection/browse/$primarySorting/$primaryCategoryName/': typeof SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameIndexRoute
  '/cwg/browse/$primarySorting/$primaryCategoryName/': typeof SiteCwgBrowsePrimarySortingPrimaryCategoryNameIndexRoute
  '/users/collection/$username/': typeof SiteUsersPublicprofileCollectionUsernameIndexRoute
  '/users/notwant/$username/': typeof SiteUsersPublicprofileNotwantUsernameIndexRoute
  '/users/offers/$username/': typeof SiteUsersPublicprofileOffersUsernameIndexRoute
  '/users/wants/$username/': typeof SiteUsersPublicprofileWantsUsernameIndexRoute
  '/users/collection/$username/$primarySorting/$primaryCategoryName': typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameRouteRouteWithChildren
  '/users/notwant/$username/$primarySorting/$primaryCategoryName': typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameRouteRouteWithChildren
  '/users/offers/$username/$primarySorting/$primaryCategoryName': typeof SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameRouteRouteWithChildren
  '/users/wants/$username/$primarySorting/$primaryCategoryName': typeof SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameRouteRouteWithChildren
  '/cwg-collection/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName/': typeof SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute
  '/cwg-collection/browse/$primarySorting/$primaryCategoryName/all/': typeof SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameAllIndexRoute
  '/cwg/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName/': typeof SiteCwgBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute
  '/users/collection/$username/$primarySorting/': typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingIndexRoute
  '/users/notwant/$username/$primarySorting/': typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingIndexRoute
  '/users/offers/$username/$primarySorting/': typeof SiteUsersPublicprofileOffersUsernamePrimarySortingIndexRoute
  '/users/wants/$username/$primarySorting/': typeof SiteUsersPublicprofileWantsUsernamePrimarySortingIndexRoute
  '/users/collection/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName': typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteWithChildren
  '/users/collection/$username/$primarySorting/$primaryCategoryName/all': typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameAllRouteRouteWithChildren
  '/users/notwant/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName': typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteWithChildren
  '/users/notwant/$username/$primarySorting/$primaryCategoryName/all': typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameAllRouteRouteWithChildren
  '/users/offers/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName': typeof SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteWithChildren
  '/users/offers/$username/$primarySorting/$primaryCategoryName/all': typeof SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameAllRouteRouteWithChildren
  '/users/wants/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName': typeof SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteWithChildren
  '/users/wants/$username/$primarySorting/$primaryCategoryName/all': typeof SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameAllRouteRouteWithChildren
  '/users/collection/$username/$primarySorting/$primaryCategoryName/': typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameIndexRoute
  '/users/notwant/$username/$primarySorting/$primaryCategoryName/': typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameIndexRoute
  '/users/offers/$username/$primarySorting/$primaryCategoryName/': typeof SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameIndexRoute
  '/users/wants/$username/$primarySorting/$primaryCategoryName/': typeof SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameIndexRoute
  '/users/collection/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/': typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute
  '/users/collection/$username/$primarySorting/$primaryCategoryName/all/': typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameAllIndexRoute
  '/users/notwant/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/': typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute
  '/users/notwant/$username/$primarySorting/$primaryCategoryName/all/': typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameAllIndexRoute
  '/users/offers/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/': typeof SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute
  '/users/offers/$username/$primarySorting/$primaryCategoryName/all/': typeof SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameAllIndexRoute
  '/users/wants/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/': typeof SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute
  '/users/wants/$username/$primarySorting/$primaryCategoryName/all/': typeof SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameAllIndexRoute
}

export interface FileRoutesByTo {
  '/cwg': typeof SiteCwgRouteRouteWithChildren
  '/users': typeof SiteUsersPublicprofileRouteRouteWithChildren
  '/change-password': typeof SiteChangePasswordRoute
  '/recover-password': typeof SiteRecoverPasswordRoute
  '/report': typeof SiteReportRoute
  '/verify-email': typeof SiteVerifyEmailRoute
  '/login/authorize': typeof LoginAuthorizeRoute
  '/': typeof SiteIndexRoute
  '/login': typeof LoginIndexRoute
  '/applications/$clientId': typeof SiteApplicationsClientIdRoute
  '/applications/register': typeof SiteApplicationsRegisterRoute
  '/cwg-collection/duplicates': typeof SiteCwgCollectionDuplicatesRoute
  '/cwg-collection/tags': typeof SiteCwgCollectionTagsRoute
  '/cwg-main/api': typeof SiteCwgMainApiRoute
  '/cwg/entry': typeof SiteCwgEntryRoute
  '/cwg/own': typeof SiteCwgOwnRoute
  '/messages/$threadId': typeof SiteMessagesThreadIdRoute
  '/messages/new': typeof SiteMessagesNewRoute
  '/news/archive': typeof SiteNewsArchiveRoute
  '/users/profile': typeof SiteUsersProfileRoute
  '/users/stats': typeof SiteUsersStatsRoute
  '/users/stats_offers': typeof SiteUsersStatsoffersRoute
  '/admin': typeof SiteAdminIndexRoute
  '/applications': typeof SiteApplicationsIndexRoute
  '/messages': typeof SiteMessagesIndexRoute
  '/admin/approving': typeof SiteAdminApprovingQueueIndexRoute
  '/admin/groups/create': typeof SiteAdminGroupsCreateRoute
  '/admin/news/create': typeof SiteAdminNewsCreateRoute
  '/cwg-collection/browse/all': typeof SiteCwgCollectionBrowseAllRoute
  '/cwg/modify/$xwgId': typeof SiteCwgModifyXwgIdRoute
  '/cwg/search/$query': typeof SiteCwgSearchQueryRoute
  '/users/search/$username': typeof SiteUsersSearchUsernameRoute
  '/admin/groups': typeof SiteAdminGroupsIndexRoute
  '/admin/news': typeof SiteAdminNewsIndexRoute
  '/admin/users': typeof SiteAdminUsersIndexRoute
  '/cwg-collection/browse': typeof SiteCwgCollectionBrowseIndexRoute
  '/cwg/browse': typeof SiteCwgBrowseIndexRoute
  '/cwg/search': typeof SiteCwgSearchIndexRoute
  '/users/search': typeof SiteUsersSearchIndexRoute
  '/news/index/$id': typeof SiteNewsIndexIdRoute
  '/admin/approving/all': typeof SiteAdminApprovingQueueAllRoute
  '/admin/approving/holds': typeof SiteAdminApprovingQueueHoldsRoute
  '/admin/groups/$groupId/modify': typeof SiteAdminGroupsGroupIdModifyRoute
  '/admin/news/modify/$id': typeof SiteAdminNewsModifyIdRoute
  '/admin/users/$userId/groups': typeof SiteAdminUsersUserIdGroupsRoute
  '/admin/users/$userId/privileges': typeof SiteAdminUsersUserIdPrivilegesRoute
  '/cwg/browse/advanced/$filter': typeof SiteCwgBrowseAdvancedFilterRoute
  '/users/messages/$username': typeof SiteUsersPublicprofileMessagesUsernameRoute
  '/cwg-collection/browse/$primarySorting': typeof SiteCwgCollectionBrowsePrimarySortingIndexRoute
  '/cwg/browse/$primarySorting': typeof SiteCwgBrowsePrimarySortingIndexRoute
  '/cwg/browse/advanced': typeof SiteCwgBrowseAdvancedIndexRoute
  '/cwg/index/$xwgId': typeof SiteCwgIndexXwgIdIndexRoute
  '/cwg/index/$xwgId/images': typeof SiteCwgIndexXwgIdImagesRoute
  '/cwg/index/$xwgId/join': typeof SiteCwgIndexXwgIdJoinRoute
  '/users/index/$username': typeof SiteUsersPublicprofileIndexUsernameRoute
  '/users/collection/$username/all': typeof SiteUsersPublicprofileCollectionUsernameAllRoute
  '/users/notwant/$username/all': typeof SiteUsersPublicprofileNotwantUsernameAllRoute
  '/users/offers/$username/all': typeof SiteUsersPublicprofileOffersUsernameAllRoute
  '/users/wants/$username/all': typeof SiteUsersPublicprofileWantsUsernameAllRoute
  '/cwg-collection/browse/$primarySorting/$primaryCategoryName': typeof SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameIndexRoute
  '/cwg/browse/$primarySorting/$primaryCategoryName': typeof SiteCwgBrowsePrimarySortingPrimaryCategoryNameIndexRoute
  '/users/collection/$username': typeof SiteUsersPublicprofileCollectionUsernameIndexRoute
  '/users/notwant/$username': typeof SiteUsersPublicprofileNotwantUsernameIndexRoute
  '/users/offers/$username': typeof SiteUsersPublicprofileOffersUsernameIndexRoute
  '/users/wants/$username': typeof SiteUsersPublicprofileWantsUsernameIndexRoute
  '/cwg-collection/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName': typeof SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute
  '/cwg-collection/browse/$primarySorting/$primaryCategoryName/all': typeof SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameAllIndexRoute
  '/cwg/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName': typeof SiteCwgBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute
  '/users/collection/$username/$primarySorting': typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingIndexRoute
  '/users/notwant/$username/$primarySorting': typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingIndexRoute
  '/users/offers/$username/$primarySorting': typeof SiteUsersPublicprofileOffersUsernamePrimarySortingIndexRoute
  '/users/wants/$username/$primarySorting': typeof SiteUsersPublicprofileWantsUsernamePrimarySortingIndexRoute
  '/users/collection/$username/$primarySorting/$primaryCategoryName': typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameIndexRoute
  '/users/notwant/$username/$primarySorting/$primaryCategoryName': typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameIndexRoute
  '/users/offers/$username/$primarySorting/$primaryCategoryName': typeof SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameIndexRoute
  '/users/wants/$username/$primarySorting/$primaryCategoryName': typeof SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameIndexRoute
  '/users/collection/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName': typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute
  '/users/collection/$username/$primarySorting/$primaryCategoryName/all': typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameAllIndexRoute
  '/users/notwant/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName': typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute
  '/users/notwant/$username/$primarySorting/$primaryCategoryName/all': typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameAllIndexRoute
  '/users/offers/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName': typeof SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute
  '/users/offers/$username/$primarySorting/$primaryCategoryName/all': typeof SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameAllIndexRoute
  '/users/wants/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName': typeof SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute
  '/users/wants/$username/$primarySorting/$primaryCategoryName/all': typeof SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameAllIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_site': typeof SiteRouteRouteWithChildren
  '/login': typeof LoginRouteRouteWithChildren
  '/_site/admin': typeof SiteAdminRouteRouteWithChildren
  '/_site/cwg': typeof SiteCwgRouteRouteWithChildren
  '/_site/messages': typeof SiteMessagesRouteRouteWithChildren
  '/_site/users': typeof SiteUsersRouteRouteWithChildren
  '/_site/change-password': typeof SiteChangePasswordRoute
  '/_site/recover-password': typeof SiteRecoverPasswordRoute
  '/_site/report': typeof SiteReportRoute
  '/_site/verify-email': typeof SiteVerifyEmailRoute
  '/login/authorize': typeof LoginAuthorizeRoute
  '/_site/': typeof SiteIndexRoute
  '/login/': typeof LoginIndexRoute
  '/_site/cwg-collection/browse': typeof SiteCwgCollectionBrowseRouteRouteWithChildren
  '/_site/cwg/browse': typeof SiteCwgBrowseRouteRouteWithChildren
  '/_site/cwg/search': typeof SiteCwgSearchRouteRouteWithChildren
  '/_site/users/_public_profile': typeof SiteUsersPublicprofileRouteRouteWithChildren
  '/_site/applications/$clientId': typeof SiteApplicationsClientIdRoute
  '/_site/applications/register': typeof SiteApplicationsRegisterRoute
  '/_site/cwg-collection/duplicates': typeof SiteCwgCollectionDuplicatesRoute
  '/_site/cwg-collection/tags': typeof SiteCwgCollectionTagsRoute
  '/_site/cwg-main/api': typeof SiteCwgMainApiRoute
  '/_site/cwg/entry': typeof SiteCwgEntryRoute
  '/_site/cwg/own': typeof SiteCwgOwnRoute
  '/_site/messages/$threadId': typeof SiteMessagesThreadIdRoute
  '/_site/messages/new': typeof SiteMessagesNewRoute
  '/_site/news/archive': typeof SiteNewsArchiveRoute
  '/_site/users/profile': typeof SiteUsersProfileRoute
  '/_site/users/stats': typeof SiteUsersStatsRoute
  '/_site/users/stats_offers': typeof SiteUsersStatsoffersRoute
  '/_site/admin/': typeof SiteAdminIndexRoute
  '/_site/applications/': typeof SiteApplicationsIndexRoute
  '/_site/messages/': typeof SiteMessagesIndexRoute
  '/_site/admin/approving': typeof SiteAdminApprovingRouteWithChildren
  '/_site/admin/approving/_queue': typeof SiteAdminApprovingQueueRouteRouteWithChildren
  '/_site/cwg-collection/browse/$primarySorting': typeof SiteCwgCollectionBrowsePrimarySortingRouteRouteWithChildren
  '/_site/cwg/browse/$primarySorting': typeof SiteCwgBrowsePrimarySortingRouteRouteWithChildren
  '/_site/cwg/browse/advanced': typeof SiteCwgBrowseAdvancedRouteRouteWithChildren
  '/_site/admin/groups/create': typeof SiteAdminGroupsCreateRoute
  '/_site/admin/news/create': typeof SiteAdminNewsCreateRoute
  '/_site/cwg-collection/browse/all': typeof SiteCwgCollectionBrowseAllRoute
  '/_site/cwg/modify/$xwgId': typeof SiteCwgModifyXwgIdRoute
  '/_site/cwg/search/$query': typeof SiteCwgSearchQueryRoute
  '/_site/users/search/$username': typeof SiteUsersSearchUsernameRoute
  '/_site/admin/groups/': typeof SiteAdminGroupsIndexRoute
  '/_site/admin/news/': typeof SiteAdminNewsIndexRoute
  '/_site/admin/users/': typeof SiteAdminUsersIndexRoute
  '/_site/cwg-collection/browse/': typeof SiteCwgCollectionBrowseIndexRoute
  '/_site/cwg/browse/': typeof SiteCwgBrowseIndexRoute
  '/_site/cwg/search/': typeof SiteCwgSearchIndexRoute
  '/_site/users/search/': typeof SiteUsersSearchIndexRoute
  '/_site/news/index/$id': typeof SiteNewsIndexIdRoute
  '/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName': typeof SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameRouteRouteWithChildren
  '/_site/cwg/browse/$primarySorting/$primaryCategoryName': typeof SiteCwgBrowsePrimarySortingPrimaryCategoryNameRouteRouteWithChildren
  '/_site/users/_public_profile/collection/$username': typeof SiteUsersPublicprofileCollectionUsernameRouteRouteWithChildren
  '/_site/users/_public_profile/notwant/$username': typeof SiteUsersPublicprofileNotwantUsernameRouteRouteWithChildren
  '/_site/users/_public_profile/offers/$username': typeof SiteUsersPublicprofileOffersUsernameRouteRouteWithChildren
  '/_site/users/_public_profile/wants/$username': typeof SiteUsersPublicprofileWantsUsernameRouteRouteWithChildren
  '/_site/admin/approving/_queue/all': typeof SiteAdminApprovingQueueAllRoute
  '/_site/admin/approving/_queue/holds': typeof SiteAdminApprovingQueueHoldsRoute
  '/_site/admin/groups/$groupId/modify': typeof SiteAdminGroupsGroupIdModifyRoute
  '/_site/admin/news/modify/$id': typeof SiteAdminNewsModifyIdRoute
  '/_site/admin/users/$userId/groups': typeof SiteAdminUsersUserIdGroupsRoute
  '/_site/admin/users/$userId/privileges': typeof SiteAdminUsersUserIdPrivilegesRoute
  '/_site/cwg/browse/advanced/$filter': typeof SiteCwgBrowseAdvancedFilterRoute
  '/_site/users/_public_profile/messages/$username': typeof SiteUsersPublicprofileMessagesUsernameRoute
  '/_site/admin/approving/_queue/': typeof SiteAdminApprovingQueueIndexRoute
  '/_site/cwg-collection/browse/$primarySorting/': typeof SiteCwgCollectionBrowsePrimarySortingIndexRoute
  '/_site/cwg/browse/$primarySorting/': typeof SiteCwgBrowsePrimarySortingIndexRoute
  '/_site/cwg/browse/advanced/': typeof SiteCwgBrowseAdvancedIndexRoute
  '/_site/cwg/index/$xwgId/': typeof SiteCwgIndexXwgIdIndexRoute
  '/_site/cwg/index/$xwgId/images': typeof SiteCwgIndexXwgIdImagesRoute
  '/_site/cwg/index/$xwgId/join': typeof SiteCwgIndexXwgIdJoinRoute
  '/_site/users/_public_profile/index/$username': typeof SiteUsersPublicprofileIndexUsernameRoute
  '/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName': typeof SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteWithChildren
  '/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/all': typeof SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameAllRouteRouteWithChildren
  '/_site/cwg/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName': typeof SiteCwgBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteWithChildren
  '/_site/users/_public_profile/collection/$username/$primarySorting': typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingRouteRouteWithChildren
  '/_site/users/_public_profile/notwant/$username/$primarySorting': typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingRouteRouteWithChildren
  '/_site/users/_public_profile/offers/$username/$primarySorting': typeof SiteUsersPublicprofileOffersUsernamePrimarySortingRouteRouteWithChildren
  '/_site/users/_public_profile/wants/$username/$primarySorting': typeof SiteUsersPublicprofileWantsUsernamePrimarySortingRouteRouteWithChildren
  '/_site/users/_public_profile/collection/$username/all': typeof SiteUsersPublicprofileCollectionUsernameAllRoute
  '/_site/users/_public_profile/notwant/$username/all': typeof SiteUsersPublicprofileNotwantUsernameAllRoute
  '/_site/users/_public_profile/offers/$username/all': typeof SiteUsersPublicprofileOffersUsernameAllRoute
  '/_site/users/_public_profile/wants/$username/all': typeof SiteUsersPublicprofileWantsUsernameAllRoute
  '/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/': typeof SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameIndexRoute
  '/_site/cwg/browse/$primarySorting/$primaryCategoryName/': typeof SiteCwgBrowsePrimarySortingPrimaryCategoryNameIndexRoute
  '/_site/users/_public_profile/collection/$username/': typeof SiteUsersPublicprofileCollectionUsernameIndexRoute
  '/_site/users/_public_profile/notwant/$username/': typeof SiteUsersPublicprofileNotwantUsernameIndexRoute
  '/_site/users/_public_profile/offers/$username/': typeof SiteUsersPublicprofileOffersUsernameIndexRoute
  '/_site/users/_public_profile/wants/$username/': typeof SiteUsersPublicprofileWantsUsernameIndexRoute
  '/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName': typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameRouteRouteWithChildren
  '/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName': typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameRouteRouteWithChildren
  '/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName': typeof SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameRouteRouteWithChildren
  '/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName': typeof SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameRouteRouteWithChildren
  '/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName/': typeof SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute
  '/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/all/': typeof SiteCwgCollectionBrowsePrimarySortingPrimaryCategoryNameAllIndexRoute
  '/_site/cwg/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName/': typeof SiteCwgBrowsePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute
  '/_site/users/_public_profile/collection/$username/$primarySorting/': typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingIndexRoute
  '/_site/users/_public_profile/notwant/$username/$primarySorting/': typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingIndexRoute
  '/_site/users/_public_profile/offers/$username/$primarySorting/': typeof SiteUsersPublicprofileOffersUsernamePrimarySortingIndexRoute
  '/_site/users/_public_profile/wants/$username/$primarySorting/': typeof SiteUsersPublicprofileWantsUsernamePrimarySortingIndexRoute
  '/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName': typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteWithChildren
  '/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName/all': typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameAllRouteRouteWithChildren
  '/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName': typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteWithChildren
  '/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName/all': typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameAllRouteRouteWithChildren
  '/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName': typeof SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteWithChildren
  '/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName/all': typeof SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameAllRouteRouteWithChildren
  '/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName': typeof SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameRouteRouteWithChildren
  '/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName/all': typeof SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameAllRouteRouteWithChildren
  '/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName/': typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameIndexRoute
  '/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName/': typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameIndexRoute
  '/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName/': typeof SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameIndexRoute
  '/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName/': typeof SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameIndexRoute
  '/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/': typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute
  '/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName/all/': typeof SiteUsersPublicprofileCollectionUsernamePrimarySortingPrimaryCategoryNameAllIndexRoute
  '/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/': typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute
  '/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName/all/': typeof SiteUsersPublicprofileNotwantUsernamePrimarySortingPrimaryCategoryNameAllIndexRoute
  '/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/': typeof SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute
  '/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName/all/': typeof SiteUsersPublicprofileOffersUsernamePrimarySortingPrimaryCategoryNameAllIndexRoute
  '/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/': typeof SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameSecondaryCategoryNameIndexRoute
  '/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName/all/': typeof SiteUsersPublicprofileWantsUsernamePrimarySortingPrimaryCategoryNameAllIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/login'
    | '/admin'
    | '/cwg'
    | '/messages'
    | '/users'
    | '/change-password'
    | '/recover-password'
    | '/report'
    | '/verify-email'
    | '/login/authorize'
    | '/'
    | '/login/'
    | '/cwg-collection/browse'
    | '/cwg/browse'
    | '/cwg/search'
    | '/applications/$clientId'
    | '/applications/register'
    | '/cwg-collection/duplicates'
    | '/cwg-collection/tags'
    | '/cwg-main/api'
    | '/cwg/entry'
    | '/cwg/own'
    | '/messages/$threadId'
    | '/messages/new'
    | '/news/archive'
    | '/users/profile'
    | '/users/stats'
    | '/users/stats_offers'
    | '/admin/'
    | '/applications'
    | '/messages/'
    | '/admin/approving'
    | '/cwg-collection/browse/$primarySorting'
    | '/cwg/browse/$primarySorting'
    | '/cwg/browse/advanced'
    | '/admin/groups/create'
    | '/admin/news/create'
    | '/cwg-collection/browse/all'
    | '/cwg/modify/$xwgId'
    | '/cwg/search/$query'
    | '/users/search/$username'
    | '/admin/groups'
    | '/admin/news'
    | '/admin/users'
    | '/cwg-collection/browse/'
    | '/cwg/browse/'
    | '/cwg/search/'
    | '/users/search'
    | '/news/index/$id'
    | '/cwg-collection/browse/$primarySorting/$primaryCategoryName'
    | '/cwg/browse/$primarySorting/$primaryCategoryName'
    | '/users/collection/$username'
    | '/users/notwant/$username'
    | '/users/offers/$username'
    | '/users/wants/$username'
    | '/admin/approving/all'
    | '/admin/approving/holds'
    | '/admin/groups/$groupId/modify'
    | '/admin/news/modify/$id'
    | '/admin/users/$userId/groups'
    | '/admin/users/$userId/privileges'
    | '/cwg/browse/advanced/$filter'
    | '/users/messages/$username'
    | '/admin/approving/'
    | '/cwg-collection/browse/$primarySorting/'
    | '/cwg/browse/$primarySorting/'
    | '/cwg/browse/advanced/'
    | '/cwg/index/$xwgId'
    | '/cwg/index/$xwgId/images'
    | '/cwg/index/$xwgId/join'
    | '/users/index/$username'
    | '/cwg-collection/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName'
    | '/cwg-collection/browse/$primarySorting/$primaryCategoryName/all'
    | '/cwg/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName'
    | '/users/collection/$username/$primarySorting'
    | '/users/notwant/$username/$primarySorting'
    | '/users/offers/$username/$primarySorting'
    | '/users/wants/$username/$primarySorting'
    | '/users/collection/$username/all'
    | '/users/notwant/$username/all'
    | '/users/offers/$username/all'
    | '/users/wants/$username/all'
    | '/cwg-collection/browse/$primarySorting/$primaryCategoryName/'
    | '/cwg/browse/$primarySorting/$primaryCategoryName/'
    | '/users/collection/$username/'
    | '/users/notwant/$username/'
    | '/users/offers/$username/'
    | '/users/wants/$username/'
    | '/users/collection/$username/$primarySorting/$primaryCategoryName'
    | '/users/notwant/$username/$primarySorting/$primaryCategoryName'
    | '/users/offers/$username/$primarySorting/$primaryCategoryName'
    | '/users/wants/$username/$primarySorting/$primaryCategoryName'
    | '/cwg-collection/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName/'
    | '/cwg-collection/browse/$primarySorting/$primaryCategoryName/all/'
    | '/cwg/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName/'
    | '/users/collection/$username/$primarySorting/'
    | '/users/notwant/$username/$primarySorting/'
    | '/users/offers/$username/$primarySorting/'
    | '/users/wants/$username/$primarySorting/'
    | '/users/collection/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName'
    | '/users/collection/$username/$primarySorting/$primaryCategoryName/all'
    | '/users/notwant/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName'
    | '/users/notwant/$username/$primarySorting/$primaryCategoryName/all'
    | '/users/offers/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName'
    | '/users/offers/$username/$primarySorting/$primaryCategoryName/all'
    | '/users/wants/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName'
    | '/users/wants/$username/$primarySorting/$primaryCategoryName/all'
    | '/users/collection/$username/$primarySorting/$primaryCategoryName/'
    | '/users/notwant/$username/$primarySorting/$primaryCategoryName/'
    | '/users/offers/$username/$primarySorting/$primaryCategoryName/'
    | '/users/wants/$username/$primarySorting/$primaryCategoryName/'
    | '/users/collection/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/'
    | '/users/collection/$username/$primarySorting/$primaryCategoryName/all/'
    | '/users/notwant/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/'
    | '/users/notwant/$username/$primarySorting/$primaryCategoryName/all/'
    | '/users/offers/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/'
    | '/users/offers/$username/$primarySorting/$primaryCategoryName/all/'
    | '/users/wants/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/'
    | '/users/wants/$username/$primarySorting/$primaryCategoryName/all/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/cwg'
    | '/users'
    | '/change-password'
    | '/recover-password'
    | '/report'
    | '/verify-email'
    | '/login/authorize'
    | '/'
    | '/login'
    | '/applications/$clientId'
    | '/applications/register'
    | '/cwg-collection/duplicates'
    | '/cwg-collection/tags'
    | '/cwg-main/api'
    | '/cwg/entry'
    | '/cwg/own'
    | '/messages/$threadId'
    | '/messages/new'
    | '/news/archive'
    | '/users/profile'
    | '/users/stats'
    | '/users/stats_offers'
    | '/admin'
    | '/applications'
    | '/messages'
    | '/admin/approving'
    | '/admin/groups/create'
    | '/admin/news/create'
    | '/cwg-collection/browse/all'
    | '/cwg/modify/$xwgId'
    | '/cwg/search/$query'
    | '/users/search/$username'
    | '/admin/groups'
    | '/admin/news'
    | '/admin/users'
    | '/cwg-collection/browse'
    | '/cwg/browse'
    | '/cwg/search'
    | '/users/search'
    | '/news/index/$id'
    | '/admin/approving/all'
    | '/admin/approving/holds'
    | '/admin/groups/$groupId/modify'
    | '/admin/news/modify/$id'
    | '/admin/users/$userId/groups'
    | '/admin/users/$userId/privileges'
    | '/cwg/browse/advanced/$filter'
    | '/users/messages/$username'
    | '/cwg-collection/browse/$primarySorting'
    | '/cwg/browse/$primarySorting'
    | '/cwg/browse/advanced'
    | '/cwg/index/$xwgId'
    | '/cwg/index/$xwgId/images'
    | '/cwg/index/$xwgId/join'
    | '/users/index/$username'
    | '/users/collection/$username/all'
    | '/users/notwant/$username/all'
    | '/users/offers/$username/all'
    | '/users/wants/$username/all'
    | '/cwg-collection/browse/$primarySorting/$primaryCategoryName'
    | '/cwg/browse/$primarySorting/$primaryCategoryName'
    | '/users/collection/$username'
    | '/users/notwant/$username'
    | '/users/offers/$username'
    | '/users/wants/$username'
    | '/cwg-collection/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName'
    | '/cwg-collection/browse/$primarySorting/$primaryCategoryName/all'
    | '/cwg/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName'
    | '/users/collection/$username/$primarySorting'
    | '/users/notwant/$username/$primarySorting'
    | '/users/offers/$username/$primarySorting'
    | '/users/wants/$username/$primarySorting'
    | '/users/collection/$username/$primarySorting/$primaryCategoryName'
    | '/users/notwant/$username/$primarySorting/$primaryCategoryName'
    | '/users/offers/$username/$primarySorting/$primaryCategoryName'
    | '/users/wants/$username/$primarySorting/$primaryCategoryName'
    | '/users/collection/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName'
    | '/users/collection/$username/$primarySorting/$primaryCategoryName/all'
    | '/users/notwant/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName'
    | '/users/notwant/$username/$primarySorting/$primaryCategoryName/all'
    | '/users/offers/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName'
    | '/users/offers/$username/$primarySorting/$primaryCategoryName/all'
    | '/users/wants/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName'
    | '/users/wants/$username/$primarySorting/$primaryCategoryName/all'
  id:
    | '__root__'
    | '/_site'
    | '/login'
    | '/_site/admin'
    | '/_site/cwg'
    | '/_site/messages'
    | '/_site/users'
    | '/_site/change-password'
    | '/_site/recover-password'
    | '/_site/report'
    | '/_site/verify-email'
    | '/login/authorize'
    | '/_site/'
    | '/login/'
    | '/_site/cwg-collection/browse'
    | '/_site/cwg/browse'
    | '/_site/cwg/search'
    | '/_site/users/_public_profile'
    | '/_site/applications/$clientId'
    | '/_site/applications/register'
    | '/_site/cwg-collection/duplicates'
    | '/_site/cwg-collection/tags'
    | '/_site/cwg-main/api'
    | '/_site/cwg/entry'
    | '/_site/cwg/own'
    | '/_site/messages/$threadId'
    | '/_site/messages/new'
    | '/_site/news/archive'
    | '/_site/users/profile'
    | '/_site/users/stats'
    | '/_site/users/stats_offers'
    | '/_site/admin/'
    | '/_site/applications/'
    | '/_site/messages/'
    | '/_site/admin/approving'
    | '/_site/admin/approving/_queue'
    | '/_site/cwg-collection/browse/$primarySorting'
    | '/_site/cwg/browse/$primarySorting'
    | '/_site/cwg/browse/advanced'
    | '/_site/admin/groups/create'
    | '/_site/admin/news/create'
    | '/_site/cwg-collection/browse/all'
    | '/_site/cwg/modify/$xwgId'
    | '/_site/cwg/search/$query'
    | '/_site/users/search/$username'
    | '/_site/admin/groups/'
    | '/_site/admin/news/'
    | '/_site/admin/users/'
    | '/_site/cwg-collection/browse/'
    | '/_site/cwg/browse/'
    | '/_site/cwg/search/'
    | '/_site/users/search/'
    | '/_site/news/index/$id'
    | '/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName'
    | '/_site/cwg/browse/$primarySorting/$primaryCategoryName'
    | '/_site/users/_public_profile/collection/$username'
    | '/_site/users/_public_profile/notwant/$username'
    | '/_site/users/_public_profile/offers/$username'
    | '/_site/users/_public_profile/wants/$username'
    | '/_site/admin/approving/_queue/all'
    | '/_site/admin/approving/_queue/holds'
    | '/_site/admin/groups/$groupId/modify'
    | '/_site/admin/news/modify/$id'
    | '/_site/admin/users/$userId/groups'
    | '/_site/admin/users/$userId/privileges'
    | '/_site/cwg/browse/advanced/$filter'
    | '/_site/users/_public_profile/messages/$username'
    | '/_site/admin/approving/_queue/'
    | '/_site/cwg-collection/browse/$primarySorting/'
    | '/_site/cwg/browse/$primarySorting/'
    | '/_site/cwg/browse/advanced/'
    | '/_site/cwg/index/$xwgId/'
    | '/_site/cwg/index/$xwgId/images'
    | '/_site/cwg/index/$xwgId/join'
    | '/_site/users/_public_profile/index/$username'
    | '/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName'
    | '/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/all'
    | '/_site/cwg/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName'
    | '/_site/users/_public_profile/collection/$username/$primarySorting'
    | '/_site/users/_public_profile/notwant/$username/$primarySorting'
    | '/_site/users/_public_profile/offers/$username/$primarySorting'
    | '/_site/users/_public_profile/wants/$username/$primarySorting'
    | '/_site/users/_public_profile/collection/$username/all'
    | '/_site/users/_public_profile/notwant/$username/all'
    | '/_site/users/_public_profile/offers/$username/all'
    | '/_site/users/_public_profile/wants/$username/all'
    | '/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/'
    | '/_site/cwg/browse/$primarySorting/$primaryCategoryName/'
    | '/_site/users/_public_profile/collection/$username/'
    | '/_site/users/_public_profile/notwant/$username/'
    | '/_site/users/_public_profile/offers/$username/'
    | '/_site/users/_public_profile/wants/$username/'
    | '/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName'
    | '/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName'
    | '/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName'
    | '/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName'
    | '/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName/'
    | '/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/all/'
    | '/_site/cwg/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName/'
    | '/_site/users/_public_profile/collection/$username/$primarySorting/'
    | '/_site/users/_public_profile/notwant/$username/$primarySorting/'
    | '/_site/users/_public_profile/offers/$username/$primarySorting/'
    | '/_site/users/_public_profile/wants/$username/$primarySorting/'
    | '/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName'
    | '/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName/all'
    | '/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName'
    | '/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName/all'
    | '/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName'
    | '/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName/all'
    | '/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName'
    | '/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName/all'
    | '/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName/'
    | '/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName/'
    | '/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName/'
    | '/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName/'
    | '/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/'
    | '/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName/all/'
    | '/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/'
    | '/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName/all/'
    | '/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/'
    | '/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName/all/'
    | '/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/'
    | '/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName/all/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  SiteRouteRoute: typeof SiteRouteRouteWithChildren
  LoginRouteRoute: typeof LoginRouteRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  SiteRouteRoute: SiteRouteRouteWithChildren,
  LoginRouteRoute: LoginRouteRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_site",
        "/login"
      ]
    },
    "/_site": {
      "filePath": "_site/route.tsx",
      "children": [
        "/_site/admin",
        "/_site/cwg",
        "/_site/messages",
        "/_site/users",
        "/_site/change-password",
        "/_site/recover-password",
        "/_site/report",
        "/_site/verify-email",
        "/_site/",
        "/_site/cwg-collection/browse",
        "/_site/applications/$clientId",
        "/_site/applications/register",
        "/_site/cwg-collection/duplicates",
        "/_site/cwg-collection/tags",
        "/_site/cwg-main/api",
        "/_site/news/archive",
        "/_site/applications/",
        "/_site/news/index/$id"
      ]
    },
    "/login": {
      "filePath": "login/route.tsx",
      "children": [
        "/login/authorize",
        "/login/"
      ]
    },
    "/_site/admin": {
      "filePath": "_site/admin/route.tsx",
      "parent": "/_site",
      "children": [
        "/_site/admin/",
        "/_site/admin/approving",
        "/_site/admin/groups/create",
        "/_site/admin/news/create",
        "/_site/admin/groups/",
        "/_site/admin/news/",
        "/_site/admin/users/",
        "/_site/admin/groups/$groupId/modify",
        "/_site/admin/news/modify/$id",
        "/_site/admin/users/$userId/groups",
        "/_site/admin/users/$userId/privileges"
      ]
    },
    "/_site/cwg": {
      "filePath": "_site/cwg/route.tsx",
      "parent": "/_site",
      "children": [
        "/_site/cwg/browse",
        "/_site/cwg/search",
        "/_site/cwg/entry",
        "/_site/cwg/own",
        "/_site/cwg/modify/$xwgId",
        "/_site/cwg/index/$xwgId/",
        "/_site/cwg/index/$xwgId/images",
        "/_site/cwg/index/$xwgId/join"
      ]
    },
    "/_site/messages": {
      "filePath": "_site/messages/route.tsx",
      "parent": "/_site",
      "children": [
        "/_site/messages/$threadId",
        "/_site/messages/new",
        "/_site/messages/"
      ]
    },
    "/_site/users": {
      "filePath": "_site/users/route.tsx",
      "parent": "/_site",
      "children": [
        "/_site/users/_public_profile",
        "/_site/users/profile",
        "/_site/users/stats",
        "/_site/users/stats_offers",
        "/_site/users/search/$username",
        "/_site/users/search/"
      ]
    },
    "/_site/change-password": {
      "filePath": "_site/change-password.tsx",
      "parent": "/_site"
    },
    "/_site/recover-password": {
      "filePath": "_site/recover-password.tsx",
      "parent": "/_site"
    },
    "/_site/report": {
      "filePath": "_site/report.tsx",
      "parent": "/_site"
    },
    "/_site/verify-email": {
      "filePath": "_site/verify-email.tsx",
      "parent": "/_site"
    },
    "/login/authorize": {
      "filePath": "login/authorize.tsx",
      "parent": "/login"
    },
    "/_site/": {
      "filePath": "_site/index.tsx",
      "parent": "/_site"
    },
    "/login/": {
      "filePath": "login/index.tsx",
      "parent": "/login"
    },
    "/_site/cwg-collection/browse": {
      "filePath": "_site/cwg-collection/browse/route.tsx",
      "parent": "/_site",
      "children": [
        "/_site/cwg-collection/browse/$primarySorting",
        "/_site/cwg-collection/browse/all",
        "/_site/cwg-collection/browse/"
      ]
    },
    "/_site/cwg/browse": {
      "filePath": "_site/cwg/browse/route.tsx",
      "parent": "/_site/cwg",
      "children": [
        "/_site/cwg/browse/$primarySorting",
        "/_site/cwg/browse/advanced",
        "/_site/cwg/browse/"
      ]
    },
    "/_site/cwg/search": {
      "filePath": "_site/cwg/search/route.tsx",
      "parent": "/_site/cwg",
      "children": [
        "/_site/cwg/search/$query",
        "/_site/cwg/search/"
      ]
    },
    "/_site/users/_public_profile": {
      "filePath": "_site/users/_public_profile/route.tsx",
      "parent": "/_site/users",
      "children": [
        "/_site/users/_public_profile/collection/$username",
        "/_site/users/_public_profile/notwant/$username",
        "/_site/users/_public_profile/offers/$username",
        "/_site/users/_public_profile/wants/$username",
        "/_site/users/_public_profile/messages/$username",
        "/_site/users/_public_profile/index/$username"
      ]
    },
    "/_site/applications/$clientId": {
      "filePath": "_site/applications/$clientId.tsx",
      "parent": "/_site"
    },
    "/_site/applications/register": {
      "filePath": "_site/applications/register.tsx",
      "parent": "/_site"
    },
    "/_site/cwg-collection/duplicates": {
      "filePath": "_site/cwg-collection/duplicates.tsx",
      "parent": "/_site"
    },
    "/_site/cwg-collection/tags": {
      "filePath": "_site/cwg-collection/tags.tsx",
      "parent": "/_site"
    },
    "/_site/cwg-main/api": {
      "filePath": "_site/cwg-main/api.tsx",
      "parent": "/_site"
    },
    "/_site/cwg/entry": {
      "filePath": "_site/cwg/entry.tsx",
      "parent": "/_site/cwg"
    },
    "/_site/cwg/own": {
      "filePath": "_site/cwg/own.tsx",
      "parent": "/_site/cwg"
    },
    "/_site/messages/$threadId": {
      "filePath": "_site/messages/$threadId.tsx",
      "parent": "/_site/messages"
    },
    "/_site/messages/new": {
      "filePath": "_site/messages/new.tsx",
      "parent": "/_site/messages"
    },
    "/_site/news/archive": {
      "filePath": "_site/news/archive.tsx",
      "parent": "/_site"
    },
    "/_site/users/profile": {
      "filePath": "_site/users/profile.tsx",
      "parent": "/_site/users"
    },
    "/_site/users/stats": {
      "filePath": "_site/users/stats.tsx",
      "parent": "/_site/users"
    },
    "/_site/users/stats_offers": {
      "filePath": "_site/users/stats_offers.tsx",
      "parent": "/_site/users"
    },
    "/_site/admin/": {
      "filePath": "_site/admin/index.tsx",
      "parent": "/_site/admin"
    },
    "/_site/applications/": {
      "filePath": "_site/applications/index.tsx",
      "parent": "/_site"
    },
    "/_site/messages/": {
      "filePath": "_site/messages/index.tsx",
      "parent": "/_site/messages"
    },
    "/_site/admin/approving": {
      "filePath": "_site/admin/approving/_queue",
      "parent": "/_site/admin",
      "children": [
        "/_site/admin/approving/_queue"
      ]
    },
    "/_site/admin/approving/_queue": {
      "filePath": "_site/admin/approving/_queue/route.tsx",
      "parent": "/_site/admin/approving",
      "children": [
        "/_site/admin/approving/_queue/all",
        "/_site/admin/approving/_queue/holds",
        "/_site/admin/approving/_queue/"
      ]
    },
    "/_site/cwg-collection/browse/$primarySorting": {
      "filePath": "_site/cwg-collection/browse/$primarySorting/route.tsx",
      "parent": "/_site/cwg-collection/browse",
      "children": [
        "/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName",
        "/_site/cwg-collection/browse/$primarySorting/"
      ]
    },
    "/_site/cwg/browse/$primarySorting": {
      "filePath": "_site/cwg/browse/$primarySorting/route.tsx",
      "parent": "/_site/cwg/browse",
      "children": [
        "/_site/cwg/browse/$primarySorting/$primaryCategoryName",
        "/_site/cwg/browse/$primarySorting/"
      ]
    },
    "/_site/cwg/browse/advanced": {
      "filePath": "_site/cwg/browse/advanced/route.tsx",
      "parent": "/_site/cwg/browse",
      "children": [
        "/_site/cwg/browse/advanced/$filter",
        "/_site/cwg/browse/advanced/"
      ]
    },
    "/_site/admin/groups/create": {
      "filePath": "_site/admin/groups/create.tsx",
      "parent": "/_site/admin"
    },
    "/_site/admin/news/create": {
      "filePath": "_site/admin/news/create.tsx",
      "parent": "/_site/admin"
    },
    "/_site/cwg-collection/browse/all": {
      "filePath": "_site/cwg-collection/browse/all.tsx",
      "parent": "/_site/cwg-collection/browse"
    },
    "/_site/cwg/modify/$xwgId": {
      "filePath": "_site/cwg/modify.$xwgId.tsx",
      "parent": "/_site/cwg"
    },
    "/_site/cwg/search/$query": {
      "filePath": "_site/cwg/search/$query.tsx",
      "parent": "/_site/cwg/search"
    },
    "/_site/users/search/$username": {
      "filePath": "_site/users/search/$username.tsx",
      "parent": "/_site/users"
    },
    "/_site/admin/groups/": {
      "filePath": "_site/admin/groups/index.tsx",
      "parent": "/_site/admin"
    },
    "/_site/admin/news/": {
      "filePath": "_site/admin/news/index.tsx",
      "parent": "/_site/admin"
    },
    "/_site/admin/users/": {
      "filePath": "_site/admin/users/index.tsx",
      "parent": "/_site/admin"
    },
    "/_site/cwg-collection/browse/": {
      "filePath": "_site/cwg-collection/browse/index.tsx",
      "parent": "/_site/cwg-collection/browse"
    },
    "/_site/cwg/browse/": {
      "filePath": "_site/cwg/browse/index.tsx",
      "parent": "/_site/cwg/browse"
    },
    "/_site/cwg/search/": {
      "filePath": "_site/cwg/search/index.tsx",
      "parent": "/_site/cwg/search"
    },
    "/_site/users/search/": {
      "filePath": "_site/users/search/index.tsx",
      "parent": "/_site/users"
    },
    "/_site/news/index/$id": {
      "filePath": "_site/news/index.$id.tsx",
      "parent": "/_site"
    },
    "/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName": {
      "filePath": "_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/route.tsx",
      "parent": "/_site/cwg-collection/browse/$primarySorting",
      "children": [
        "/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName",
        "/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/all",
        "/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/"
      ]
    },
    "/_site/cwg/browse/$primarySorting/$primaryCategoryName": {
      "filePath": "_site/cwg/browse/$primarySorting/$primaryCategoryName/route.tsx",
      "parent": "/_site/cwg/browse/$primarySorting",
      "children": [
        "/_site/cwg/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName",
        "/_site/cwg/browse/$primarySorting/$primaryCategoryName/"
      ]
    },
    "/_site/users/_public_profile/collection/$username": {
      "filePath": "_site/users/_public_profile/collection.$username/route.tsx",
      "parent": "/_site/users/_public_profile",
      "children": [
        "/_site/users/_public_profile/collection/$username/$primarySorting",
        "/_site/users/_public_profile/collection/$username/all",
        "/_site/users/_public_profile/collection/$username/"
      ]
    },
    "/_site/users/_public_profile/notwant/$username": {
      "filePath": "_site/users/_public_profile/notwant.$username/route.tsx",
      "parent": "/_site/users/_public_profile",
      "children": [
        "/_site/users/_public_profile/notwant/$username/$primarySorting",
        "/_site/users/_public_profile/notwant/$username/all",
        "/_site/users/_public_profile/notwant/$username/"
      ]
    },
    "/_site/users/_public_profile/offers/$username": {
      "filePath": "_site/users/_public_profile/offers.$username/route.tsx",
      "parent": "/_site/users/_public_profile",
      "children": [
        "/_site/users/_public_profile/offers/$username/$primarySorting",
        "/_site/users/_public_profile/offers/$username/all",
        "/_site/users/_public_profile/offers/$username/"
      ]
    },
    "/_site/users/_public_profile/wants/$username": {
      "filePath": "_site/users/_public_profile/wants.$username/route.tsx",
      "parent": "/_site/users/_public_profile",
      "children": [
        "/_site/users/_public_profile/wants/$username/$primarySorting",
        "/_site/users/_public_profile/wants/$username/all",
        "/_site/users/_public_profile/wants/$username/"
      ]
    },
    "/_site/admin/approving/_queue/all": {
      "filePath": "_site/admin/approving/_queue/all.tsx",
      "parent": "/_site/admin/approving/_queue"
    },
    "/_site/admin/approving/_queue/holds": {
      "filePath": "_site/admin/approving/_queue/holds.tsx",
      "parent": "/_site/admin/approving/_queue"
    },
    "/_site/admin/groups/$groupId/modify": {
      "filePath": "_site/admin/groups/$groupId.modify.tsx",
      "parent": "/_site/admin"
    },
    "/_site/admin/news/modify/$id": {
      "filePath": "_site/admin/news/modify.$id.tsx",
      "parent": "/_site/admin"
    },
    "/_site/admin/users/$userId/groups": {
      "filePath": "_site/admin/users/$userId.groups.tsx",
      "parent": "/_site/admin"
    },
    "/_site/admin/users/$userId/privileges": {
      "filePath": "_site/admin/users/$userId.privileges.tsx",
      "parent": "/_site/admin"
    },
    "/_site/cwg/browse/advanced/$filter": {
      "filePath": "_site/cwg/browse/advanced/$filter.tsx",
      "parent": "/_site/cwg/browse/advanced"
    },
    "/_site/users/_public_profile/messages/$username": {
      "filePath": "_site/users/_public_profile/messages.$username.tsx",
      "parent": "/_site/users/_public_profile"
    },
    "/_site/admin/approving/_queue/": {
      "filePath": "_site/admin/approving/_queue/index.tsx",
      "parent": "/_site/admin/approving/_queue"
    },
    "/_site/cwg-collection/browse/$primarySorting/": {
      "filePath": "_site/cwg-collection/browse/$primarySorting/index.tsx",
      "parent": "/_site/cwg-collection/browse/$primarySorting"
    },
    "/_site/cwg/browse/$primarySorting/": {
      "filePath": "_site/cwg/browse/$primarySorting/index.tsx",
      "parent": "/_site/cwg/browse/$primarySorting"
    },
    "/_site/cwg/browse/advanced/": {
      "filePath": "_site/cwg/browse/advanced/index.tsx",
      "parent": "/_site/cwg/browse/advanced"
    },
    "/_site/cwg/index/$xwgId/": {
      "filePath": "_site/cwg/index.$xwgId/index.tsx",
      "parent": "/_site/cwg"
    },
    "/_site/cwg/index/$xwgId/images": {
      "filePath": "_site/cwg/index.$xwgId/images.tsx",
      "parent": "/_site/cwg"
    },
    "/_site/cwg/index/$xwgId/join": {
      "filePath": "_site/cwg/index.$xwgId/join.tsx",
      "parent": "/_site/cwg"
    },
    "/_site/users/_public_profile/index/$username": {
      "filePath": "_site/users/_public_profile/index.$username.tsx",
      "parent": "/_site/users/_public_profile"
    },
    "/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName": {
      "filePath": "_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName/route.tsx",
      "parent": "/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName",
      "children": [
        "/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName/"
      ]
    },
    "/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/all": {
      "filePath": "_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/all/route.tsx",
      "parent": "/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName",
      "children": [
        "/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/all/"
      ]
    },
    "/_site/cwg/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName": {
      "filePath": "_site/cwg/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName/route.tsx",
      "parent": "/_site/cwg/browse/$primarySorting/$primaryCategoryName",
      "children": [
        "/_site/cwg/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName/"
      ]
    },
    "/_site/users/_public_profile/collection/$username/$primarySorting": {
      "filePath": "_site/users/_public_profile/collection.$username/$primarySorting/route.tsx",
      "parent": "/_site/users/_public_profile/collection/$username",
      "children": [
        "/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName",
        "/_site/users/_public_profile/collection/$username/$primarySorting/"
      ]
    },
    "/_site/users/_public_profile/notwant/$username/$primarySorting": {
      "filePath": "_site/users/_public_profile/notwant.$username/$primarySorting/route.tsx",
      "parent": "/_site/users/_public_profile/notwant/$username",
      "children": [
        "/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName",
        "/_site/users/_public_profile/notwant/$username/$primarySorting/"
      ]
    },
    "/_site/users/_public_profile/offers/$username/$primarySorting": {
      "filePath": "_site/users/_public_profile/offers.$username/$primarySorting/route.tsx",
      "parent": "/_site/users/_public_profile/offers/$username",
      "children": [
        "/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName",
        "/_site/users/_public_profile/offers/$username/$primarySorting/"
      ]
    },
    "/_site/users/_public_profile/wants/$username/$primarySorting": {
      "filePath": "_site/users/_public_profile/wants.$username/$primarySorting/route.tsx",
      "parent": "/_site/users/_public_profile/wants/$username",
      "children": [
        "/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName",
        "/_site/users/_public_profile/wants/$username/$primarySorting/"
      ]
    },
    "/_site/users/_public_profile/collection/$username/all": {
      "filePath": "_site/users/_public_profile/collection.$username/all.tsx",
      "parent": "/_site/users/_public_profile/collection/$username"
    },
    "/_site/users/_public_profile/notwant/$username/all": {
      "filePath": "_site/users/_public_profile/notwant.$username/all.tsx",
      "parent": "/_site/users/_public_profile/notwant/$username"
    },
    "/_site/users/_public_profile/offers/$username/all": {
      "filePath": "_site/users/_public_profile/offers.$username/all.tsx",
      "parent": "/_site/users/_public_profile/offers/$username"
    },
    "/_site/users/_public_profile/wants/$username/all": {
      "filePath": "_site/users/_public_profile/wants.$username/all.tsx",
      "parent": "/_site/users/_public_profile/wants/$username"
    },
    "/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/": {
      "filePath": "_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/index.tsx",
      "parent": "/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName"
    },
    "/_site/cwg/browse/$primarySorting/$primaryCategoryName/": {
      "filePath": "_site/cwg/browse/$primarySorting/$primaryCategoryName/index.tsx",
      "parent": "/_site/cwg/browse/$primarySorting/$primaryCategoryName"
    },
    "/_site/users/_public_profile/collection/$username/": {
      "filePath": "_site/users/_public_profile/collection.$username/index.tsx",
      "parent": "/_site/users/_public_profile/collection/$username"
    },
    "/_site/users/_public_profile/notwant/$username/": {
      "filePath": "_site/users/_public_profile/notwant.$username/index.tsx",
      "parent": "/_site/users/_public_profile/notwant/$username"
    },
    "/_site/users/_public_profile/offers/$username/": {
      "filePath": "_site/users/_public_profile/offers.$username/index.tsx",
      "parent": "/_site/users/_public_profile/offers/$username"
    },
    "/_site/users/_public_profile/wants/$username/": {
      "filePath": "_site/users/_public_profile/wants.$username/index.tsx",
      "parent": "/_site/users/_public_profile/wants/$username"
    },
    "/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName": {
      "filePath": "_site/users/_public_profile/collection.$username/$primarySorting/$primaryCategoryName/route.tsx",
      "parent": "/_site/users/_public_profile/collection/$username/$primarySorting",
      "children": [
        "/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName",
        "/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName/all",
        "/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName/"
      ]
    },
    "/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName": {
      "filePath": "_site/users/_public_profile/notwant.$username/$primarySorting/$primaryCategoryName/route.tsx",
      "parent": "/_site/users/_public_profile/notwant/$username/$primarySorting",
      "children": [
        "/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName",
        "/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName/all",
        "/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName/"
      ]
    },
    "/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName": {
      "filePath": "_site/users/_public_profile/offers.$username/$primarySorting/$primaryCategoryName/route.tsx",
      "parent": "/_site/users/_public_profile/offers/$username/$primarySorting",
      "children": [
        "/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName",
        "/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName/all",
        "/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName/"
      ]
    },
    "/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName": {
      "filePath": "_site/users/_public_profile/wants.$username/$primarySorting/$primaryCategoryName/route.tsx",
      "parent": "/_site/users/_public_profile/wants/$username/$primarySorting",
      "children": [
        "/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName",
        "/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName/all",
        "/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName/"
      ]
    },
    "/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName/": {
      "filePath": "_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName/index.tsx",
      "parent": "/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName"
    },
    "/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/all/": {
      "filePath": "_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/all/index.tsx",
      "parent": "/_site/cwg-collection/browse/$primarySorting/$primaryCategoryName/all"
    },
    "/_site/cwg/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName/": {
      "filePath": "_site/cwg/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName/index.tsx",
      "parent": "/_site/cwg/browse/$primarySorting/$primaryCategoryName/$secondaryCategoryName"
    },
    "/_site/users/_public_profile/collection/$username/$primarySorting/": {
      "filePath": "_site/users/_public_profile/collection.$username/$primarySorting/index.tsx",
      "parent": "/_site/users/_public_profile/collection/$username/$primarySorting"
    },
    "/_site/users/_public_profile/notwant/$username/$primarySorting/": {
      "filePath": "_site/users/_public_profile/notwant.$username/$primarySorting/index.tsx",
      "parent": "/_site/users/_public_profile/notwant/$username/$primarySorting"
    },
    "/_site/users/_public_profile/offers/$username/$primarySorting/": {
      "filePath": "_site/users/_public_profile/offers.$username/$primarySorting/index.tsx",
      "parent": "/_site/users/_public_profile/offers/$username/$primarySorting"
    },
    "/_site/users/_public_profile/wants/$username/$primarySorting/": {
      "filePath": "_site/users/_public_profile/wants.$username/$primarySorting/index.tsx",
      "parent": "/_site/users/_public_profile/wants/$username/$primarySorting"
    },
    "/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName": {
      "filePath": "_site/users/_public_profile/collection.$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/route.tsx",
      "parent": "/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName",
      "children": [
        "/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/"
      ]
    },
    "/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName/all": {
      "filePath": "_site/users/_public_profile/collection.$username/$primarySorting/$primaryCategoryName/all/route.tsx",
      "parent": "/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName",
      "children": [
        "/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName/all/"
      ]
    },
    "/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName": {
      "filePath": "_site/users/_public_profile/notwant.$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/route.tsx",
      "parent": "/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName",
      "children": [
        "/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/"
      ]
    },
    "/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName/all": {
      "filePath": "_site/users/_public_profile/notwant.$username/$primarySorting/$primaryCategoryName/all/route.tsx",
      "parent": "/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName",
      "children": [
        "/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName/all/"
      ]
    },
    "/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName": {
      "filePath": "_site/users/_public_profile/offers.$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/route.tsx",
      "parent": "/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName",
      "children": [
        "/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/"
      ]
    },
    "/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName/all": {
      "filePath": "_site/users/_public_profile/offers.$username/$primarySorting/$primaryCategoryName/all/route.tsx",
      "parent": "/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName",
      "children": [
        "/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName/all/"
      ]
    },
    "/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName": {
      "filePath": "_site/users/_public_profile/wants.$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/route.tsx",
      "parent": "/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName",
      "children": [
        "/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/"
      ]
    },
    "/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName/all": {
      "filePath": "_site/users/_public_profile/wants.$username/$primarySorting/$primaryCategoryName/all/route.tsx",
      "parent": "/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName",
      "children": [
        "/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName/all/"
      ]
    },
    "/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName/": {
      "filePath": "_site/users/_public_profile/collection.$username/$primarySorting/$primaryCategoryName/index.tsx",
      "parent": "/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName"
    },
    "/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName/": {
      "filePath": "_site/users/_public_profile/notwant.$username/$primarySorting/$primaryCategoryName/index.tsx",
      "parent": "/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName"
    },
    "/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName/": {
      "filePath": "_site/users/_public_profile/offers.$username/$primarySorting/$primaryCategoryName/index.tsx",
      "parent": "/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName"
    },
    "/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName/": {
      "filePath": "_site/users/_public_profile/wants.$username/$primarySorting/$primaryCategoryName/index.tsx",
      "parent": "/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName"
    },
    "/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/": {
      "filePath": "_site/users/_public_profile/collection.$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/index.tsx",
      "parent": "/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName"
    },
    "/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName/all/": {
      "filePath": "_site/users/_public_profile/collection.$username/$primarySorting/$primaryCategoryName/all/index.tsx",
      "parent": "/_site/users/_public_profile/collection/$username/$primarySorting/$primaryCategoryName/all"
    },
    "/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/": {
      "filePath": "_site/users/_public_profile/notwant.$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/index.tsx",
      "parent": "/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName"
    },
    "/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName/all/": {
      "filePath": "_site/users/_public_profile/notwant.$username/$primarySorting/$primaryCategoryName/all/index.tsx",
      "parent": "/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName/all"
    },
    "/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/": {
      "filePath": "_site/users/_public_profile/offers.$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/index.tsx",
      "parent": "/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName"
    },
    "/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName/all/": {
      "filePath": "_site/users/_public_profile/offers.$username/$primarySorting/$primaryCategoryName/all/index.tsx",
      "parent": "/_site/users/_public_profile/offers/$username/$primarySorting/$primaryCategoryName/all"
    },
    "/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/": {
      "filePath": "_site/users/_public_profile/wants.$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName/index.tsx",
      "parent": "/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName"
    },
    "/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName/all/": {
      "filePath": "_site/users/_public_profile/wants.$username/$primarySorting/$primaryCategoryName/all/index.tsx",
      "parent": "/_site/users/_public_profile/wants/$username/$primarySorting/$primaryCategoryName/all"
    }
  }
}
ROUTE_MANIFEST_END */
